(function e(t, n, r) {
    function s(o, u) {
        if (!n[o]) {
            if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); var f = new Error("Cannot find module '" + o + "'"); throw f.code = "MODULE_NOT_FOUND", f }
            var l = n[o] = { exports: {} };
            t[o][0].call(l.exports, function(e) { var n = t[o][1][e]; return s(n ? n : e) }, l, l.exports, e, t, n, r)
        }
        return n[o].exports
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s
})({
    1: [function(require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.default = {
            customers: {}
        };

    }, {}],
    2: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var El = _cacheSelectors2.default.customers;

        var Methods = {
            init: function init() {
                Methods._customerAddresses();
            },
            _customerAddresses: function _customerAddresses() {
                var $newAddressForm = $('#AddressNewForm');

                if (!$newAddressForm.length) {
                    return;
                }

                // Initialize observers on address selectors, defined in shopify_common.js
                if (Shopify) {
                    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                        hideElement: 'AddressProvinceContainerNew'
                    });
                }

                // Initialize each edit form's country/province selector
                $('.address-country-option').each(function() {
                    var formId = $(this).data('form-id');
                    var countrySelector = 'AddressCountry_' + formId;
                    var provinceSelector = 'AddressProvince_' + formId;
                    var containerSelector = 'AddressProvinceContainer_' + formId;

                    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                        hideElement: containerSelector
                    });
                });

                // Toggle new/edit address forms
                $('.address-new-toggle').on('click', function() {
                    $newAddressForm.toggleClass('is--hide');
                });

                $('.address-edit-toggle').on('click', function() {
                    var formId = $(this).data('form-id');
                    $('#EditAddress_' + formId).toggleClass('is--hide');
                });

                $('.address-delete').on('click', function() {
                    var $el = $(this);
                    var formId = $el.data('form-id');
                    var confirmMessage = $el.data('confirm-message');
                    if (confirm(confirmMessage || 'Deseja deleter este endereço?')) {
                        Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
                    }
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 1 }],
    3: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var El = _cacheSelectors2.default.customers;

        var Methods = {
            init: function init() {
                Methods._customerLogin();
            },
            _customerLogin: function _customerLogin() {
                var config = {
                    recoverPasswordForm: '#RecoverPassword',
                    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
                };

                if (!$(config.recoverPasswordForm).length) {
                    return;
                }

                checkUrlHash();
                resetPasswordSuccess();

                $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
                $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

                function onShowHidePasswordForm(e) {
                    e.preventDefault();
                    toggleRecoverPasswordForm();
                }

                function checkUrlHash() {
                    var hash = window.location.hash;

                    // Allow deep linking to recover password form
                    if (hash === '#recover') {
                        toggleRecoverPasswordForm();
                    }
                }

                /**
                 *  Show/Hide recover password form
                 */
                function toggleRecoverPasswordForm() {
                    $('#RecoverPasswordForm').toggleClass('is--hide');
                    $('#CustomerLoginForm').toggleClass('is--hide');
                }

                /**
                 *  Show reset password success message
                 */
                function resetPasswordSuccess() {
                    var $formState = $('.reset-password-success');

                    // check if reset password form was successfully submited.
                    if (!$formState.length) {
                        return;
                    }

                    // show success message
                    $('#ResetSuccess').removeClass('is--hide');
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 1 }],
    4: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _customersAddresses = require('./_customers-addresses');

        var _customersAddresses2 = _interopRequireDefault(_customersAddresses);

        var _customersLogin = require('./_customers-login');

        var _customersLogin2 = _interopRequireDefault(_customersLogin);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                _customersAddresses2.default.init();
                _customersLogin2.default.init();
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./_customers-addresses": 2, "./_customers-login": 3 }],
    5: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var Methods = {
            init: function init() {
                Methods._headerMain();
                Methods._openVideo();
            },
            _headerMain: function _headerMain() {
                $(window).scroll(function() {
                    var _offsetTop = $(window).width() > 770 ? $('.e-footer').offset().top : $('.e-footer').offset().top;
                    if ($(window).scrollTop() + $(window).height() > _offsetTop) {
                        $('#wh-widget-send-button').addClass('e-hide-whats');
                    } else {
                        $('#wh-widget-send-button').removeClass('e-hide-whats');
                    }
                });

                if ($('body').hasClass('template-product') || $('body').hasClass('template-page')) {
                    if (meta.product && meta.product.type == 'Colchão') {
                        $('.e-header__navigation ul li.e-menu-colchao').addClass('e-active');
                    } else if (meta.product && meta.product.type == 'Travesseiro') {
                        $('.e-header__navigation ul li.e-menu-travesseiro').addClass('e-active');
                    } else if (meta.product && meta.product.type == 'Toca') {
                        $('.e-header__navigation ul li.e-menu-toca').addClass('e-active');
                    } else if ((location.pathname === '/pages/lencol-e-duvet-zissou') || (meta.product && meta.product.type == 'Jogo de Lençol') || (meta.product && meta.product.type == 'Duvet')) {
                        $('.e-header__navigation ul li.e-menu-lencol-e-duvet').addClass('e-active');
                    }
                }
            },
            _openVideo: function _openVideo() {
                $('.js--video-dormireviver-zissou').click(function() {
                    var _width = $(this).find('img').width();
                    var _height = $(this).find('img').height();
                    if(!$(this).hasClass('videoPlayed')){
                        $(this).addClass('e-video').append(`
                            <video id="trialVideoDesk" class="js--lazy" style="width: 100%" loop autoplay muted playsinline>
                                <data-src class="js--lazy" style="width: 100%" media="" src="https://cdn.shopify.com/s/files/1/1526/6199/files/Dormir_Viver.mp4?v=1592607902" type="video/mp4"></data-src>
                            </video>
                        `);
                    }
                    $(this).addClass('videoPlayed')
                    $(this).find('img').hide();
                    $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100 });
                });

                $('.js--iframe-por-tras-zissou').click(function() {
                    var _width = $(this).find('img').width();
                    var _height = $(this).find('img').height();
                    if(!$(this).hasClass('videoPlayed')){
                        $(this).addClass('e-video').append(`
                            <video id="trialVideoDesk" class="js--lazy" style="width: 100%" loop autoplay muted playsinline>
                                <data-src class="js--lazy" media="" src="https://cdn.shopify.com/s/files/1/1526/6199/files/video_final_zissou_FINAL1_1_1.mp4?v=1595275448" type="video/mp4"></data-src>
                            </video>
                        `);
                    }
                    $(this).addClass('videoPlayed')
                    $(this).find('img').hide();
                    $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100 });
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    6: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var CacheSelectors = {
            minicart: {
                container: $('.js--minicart-container'),
                // collection: $('.js--minicart-collection'),
                // collectionItems: $('.js--minicart-collection-items'),
                // collectionForm: $('.js--minicart-collection-form'),
                // collectionAdded: $('.js--minicart-collection-added'),
                open: $('.js--minicart-open'),
                close: $('.js--minicart-close'),
                item: $('.js--minicart-item')
            },
            overlay: $('.js--overlay')
        };

        var Methods = {
            init: function init() {
                Methods._minicartActions();
                Methods._minicartInit();
                // Methods._minicartEvents();
                // Methods._minicartCollectionSlide();
            },
            _minicartInit: function _minicartInit() {
                $(document).on('cart.showCartOnComplete', function(ev, cart) {
                    CacheSelectors.minicart.container.add(CacheSelectors.overlay).addClass('is--active');
                    EvolveCore.triggerEvent('cart:show')
                    window.minicartApp.$store._actions.getCart[0]()
                });
            },
            _minicartActions: function _minicartActions() {
                var El = CacheSelectors.minicart;

                El.open.on('click _EV.cart:show', function(ev) {
                    ev.preventDefault();

                    if(window.ga){
                        ga('send', 'pageview', '/cart');
                    }
                    El.container.add(CacheSelectors.overlay).addClass('is--active');
                    $('html,body').addClass('is--fixed');
                });
                document.addEventListener('_EV.cart:show', function(ev) {
                    ev.preventDefault();

                    if(window.ga){
                        ga('send', 'pageview', '/cart');
                    }
                    El.container.add(CacheSelectors.overlay).addClass('is--active');
                    $('html,body').addClass('is--fixed');
                });
                
                El.close.add(CacheSelectors.overlay).on('click _EV.cart:hidden', function(ev) {
                    ev.preventDefault();

                    El.container.add(CacheSelectors.overlay).removeClass('is--active');
                    $('html,body').removeClass('is--fixed');
                });
                document.addEventListener('_EV.cart:hidden', function(ev) {
                    ev.preventDefault();

                    El.container.add(CacheSelectors.overlay).removeClass('is--active');
                    $('html,body').removeClass('is--fixed');
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    7: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var CacheSelectors = {
            mobile: {
                helpMenu: {
                    link: $('.js--help-menu-link'),
                    content: $('.js--help-menu-content')
                }
            }
        };

        var El = CacheSelectors.mobile;

        var Methods = {
            init: function init() {
                Methods._actionMenu();
            },
            _actionMenu: function _actionMenu() {
                if ($('body').width() <= 768) {
                    El.helpMenu.link.on('click', function(ev) {
                        var $this = $(ev.currentTarget);
                        var $siblings = $this.parent().siblings();

                        $siblings.find('.js--help-menu-content').slideUp();
                        $siblings.find('span').removeClass('is--rotate');
                        $this.next().slideToggle();
                        $this.children('span').toggleClass('is--rotate');
                    });
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    8: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var CacheSelectors = {
            overlay: $('.js--overlay'),
            mobile: {
                menu: $('.js--mobile-menu'),
                open: $('.js--header-mobile-open'),
                close: $('.js--header-mobile-close')
            }
        };

        var El = CacheSelectors.mobile;

        var Methods = {
            init: function init() {
                Methods._actionMenu();
                Methods.headerMobile();
            },
            _actionMenu: function _actionMenu() {
                El.open.on('click', function(ev) {
                    El.menu.add(CacheSelectors.overlay).addClass('is--active');
                });

                El.close.add(CacheSelectors.overlay).on('click', function(ev) {
                    El.menu.add(CacheSelectors.overlay).removeClass('is--active');
                });
            },
            headerMobile: function headerMobile() {
                if ($(window).width() <= 1024) {
                    $('.e-header__hamburger').click(function() {
                        $('.e-header__menu-mobile').addClass('e-active');
                    });

                    $('.e-menu-mobile-close, .e-header__menu-mobile--overlay').click(function() {
                        $('.e-header__menu-mobile').removeClass('e-active');
                    });
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    9: [function(require, module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var Methods = {
            init: function init() {},
            _newsletter: function _newsletter() {
                var formUrl = window.location.search;

                if (formUrl === '?customer_posted=true') {
                    $("html, body").animate({ scrollTop: $(document).height() }, 1000);
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    10: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var CacheSelectors = {
            section: {
                slidesItems: $('.js--section-slides-items'),
                items: $('.js--section-items'),
                img: $('.js--section-img')
            }
        };

        var El = CacheSelectors.section;

        var Methods = {
            init: function init() {
                Methods._sectionSlides();
                // Method.changeImg();
            },
            _sectionSlides: function _sectionSlides() {
                El.slidesItems.slick({
                    dots: true,
                    customPaging: function customPaging(slide, i) {
                        var name = $(slide.$slides[i]).find('li').data('section-slides-name');
                        return '<p class="x-banner-section__item">' + name + '</p>';
                    }
                });
                El.slidesItems.on('swipe afterChange', function(event, slick, direction) {
                    setTimeout(function() {
                        $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100 });
                    }, 150);
                });
            },
            changeImg: function changeImg() {
                var $items = cacheSelectors.sectionItems;
                var $img = cacheSelectors.sectionImg;
                var originalSrc = $img.data('img-src');

                $items.on('mouseenter', '.js--section-item', function(ev) {
                    var $this = $(ev.currentTarget);
                    var src = $this.data('section-img');

                    $img.attr('src', src);
                });

                $items.on('mouseleave', function(ev) {
                    $img.attr('src', originalSrc);
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    11: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var cacheSelectors = {
            cacheIcons: {
                _facebook: $('.icon_facebook'),
                _twitter: $('.icon_twitter'),
                _pinterest: $('.icon_pinterest'),
                _instagram: $('.icon_instagram'),
                _snapchat: $('.icon_snapchat'),
                _tumblr: $('.icon_tumblr'),
                _youTube: $('.icon_youTube'),
                _vimeo: $('.icon_vimeo'),
                _z_blue_full: $('.icon_z_blue_full'),
                _I_blue_full: $('.icon_I_blue_full'),
                _I_blue_out: $('.icon_I_blue_out'),
                _I_salmon_full: $('.icon_I_salmon_full'),
                _I_salmon_full_2: $('.icon_I_salmon_full_2'),
                _I_marine_full_2: $('.icon_I_marine_full_2'),
                _I_white_full_2: $('.icon_I_white_full_2')
                    // _z_white_full: $('.icon_z_white_full'),
            }
        };

        var Method = {
            init: function init() {
                Method.addSvgColors();
            },
            addSvgColors: function addSvgColors() {
                var icons = cacheSelectors.cacheIcons;

                for (var icon in icons) {
                    icons[icon].attr('class', 'icon icon' + icon + ' icon--full-color');
                }
            }
        };

        exports.default = {
            init: Method.init
        };

    }, {}],
    12: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var cacheSelectors = {};

        var Method = {
            init: function init() {
                Method.wowInit();
            },
            wowInit: function wowInit() {
                new WOW({
                    boxClass: 'is--animate',
                    offset: 100
                }).init();
            }
        };

        exports.default = {
            init: Method.init
        };

    }, {}],
    13: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _mobileHeader = require('./_mobile-header');

        var _mobileHeader2 = _interopRequireDefault(_mobileHeader);

        var _mobileFooter = require('./_mobile-footer.js');

        var _mobileFooter2 = _interopRequireDefault(_mobileFooter);

        var _minicart = require('./_minicart');

        var _minicart2 = _interopRequireDefault(_minicart);

        var _svgColors = require('./_svg-colors');

        var _svgColors2 = _interopRequireDefault(_svgColors);

        var _wowJs = require('./_wow-js');

        var _wowJs2 = _interopRequireDefault(_wowJs);

        var _sectionImg = require('./_section-img');

        var _sectionImg2 = _interopRequireDefault(_sectionImg);

        var _newsletter = require('./_newsletter');

        var _newsletter2 = _interopRequireDefault(_newsletter);

        var _headerMain = require('./_header-main');

        var _headerMain2 = _interopRequireDefault(_headerMain);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var init = function init() {
            _mobileHeader2.default.init();
            _mobileFooter2.default.init();
            _minicart2.default.init();
            _svgColors2.default.init();
            _wowJs2.default.init();
            _sectionImg2.default.init();
            _newsletter2.default.init();
            _headerMain2.default.init();
        };

        exports.default = {
            init: init
        };

    }, { "./_header-main": 5, "./_minicart": 6, "./_mobile-footer.js": 7, "./_mobile-header": 8, "./_newsletter": 9, "./_section-img": 10, "./_svg-colors": 11, "./_wow-js": 12 }],
    14: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.default = {
            home: {
                navigation: {
                    items: $('.js--navigation-items')
                },
                banner: {
                    tabs: {
                        links: $('.js--banner-product-tab-links'),
                        link: $('.js--banner-product-tab-link'),
                        content: $('.js--banner-product-tab-content')
                    },
                    img: $('.js--video-banner-img')
                },
                reviews: {
                    list: $('.e-banner-reviews__contents ul')
                }
            }
        };

    }, {}],
    15: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods.experienceZissou();
                Methods.bannerTrial();
            },
            experienceZissou: function experienceZissou() {
                if ($(window).width() < 767) {
                    var text_experience = $('.e-main-exp-zissou__contents--item:nth-child(1) p');

                    $('.e-main-exp-zissou__contents--item:nth-child(1) .e-main-exp-zissou__contents--item-image').prepend(text_experience);
                }
            },
            bannerTrial: function bannerTrial() {
                $('.e-trial-banner__contents--item .e-link').click(function(e) {
                    e.preventDefault();
                    $(this).addClass('e-active');
                    $('.e-trial-banner__contents--item-popup-text').addClass('e-active');
                });

                $('.e-trial-banner__contents--item .e-btn-close').click(function() {
                    $('.e-trial-banner__contents--item .e-link').removeClass('e-active');
                    $('.e-trial-banner__contents--item-popup-text').removeClass('e-active');
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 14 }],
    16: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var El = _cacheSelectors2.default.home.reviews;

        var Methods = {
            init: function init() {
                Methods._reviewsSlider();
                Methods._revistasSlider();
                //Methods._marcasSlider();
            },
            _reviewsSlider: function _reviewsSlider() {
                $('.e-banner-reviews__contents ul').slick({
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            arrows: false
                        }
                    }]
                });
            },
            _revistasSlider: function _revistasSlider() {
                $('.e-banner-media__contents ul').slick({
                    infinite: false,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 1.5,
                            arrows: false,
                            centerPadding: '10px',
                        }
                    }]
                });
            },
            _marcasSlider: function _marcasSlider() {
                $('.e-banner-marcas__contents ul').slick({
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: true
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 14 }],
    17: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var El = _cacheSelectors2.default.home.banner;

        var Methods = {
            init: function init() {
                Methods._productTabs();
            },
            _productTabs: function _productTabs() {
                $('.e-tabs-banner__contents--item-content .e-tabs-content').eq(0).show();
                $('.js--tabs-navigation button').eq(0).addClass('e-active');
                $('.js--tabs-navigation button').click(function() {
                    var _class = $(this).attr('class');
                    if (!$(this).hasClass('e-active')) {
                        $('.js--tabs-navigation button').removeClass('e-active');
                        $('.e-tabs-banner__contents--item-content .e-tabs-content').hide();
                        $(this).addClass('e-active');
                        $('#' + _class).slideDown();
                    }
                    return false;
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 14 }],
    18: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var El = _cacheSelectors2.default.home.banner;

        var Methods = {
            init: function init() {
                Methods.plataformVideo();
                Methods.textPlataformMobile();
            },
            plataformVideo: function plataformVideo() {
                var _videoURL = $('.js--plataform-video-url').text();
                var _videoFormatted = _videoURL.replace('watch?v=', 'embed/');
                var _videoIframe = $('.e-video-iframe js--plataform-video iframe').attr('src', _videoFormatted);
                $('.js--plataform-video-open').click(function() {
                    $('.js--plataform-video-open').hide();
                    $('.js--plataform-video iframe').fadeIn();
                });
            },
            textPlataformMobile: function textPlataformMobile() {
                if ($(window).width() < 767) {
                    var text_plataform = $('.e-plataform-banner__contents--item:nth-child(1) h3');

                    $('.e-plataform-banner__contents--item:nth-child(2)').append(text_plataform);
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors": 14 }],
    19: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _tabs = require('./_tabs');

        var _tabs2 = _interopRequireDefault(_tabs);

        var _reviews = require('./_reviews');

        var _reviews2 = _interopRequireDefault(_reviews);

        var _videos = require('./_videos');

        var _videos2 = _interopRequireDefault(_videos);

        var _experienceZissou = require('./_experience-zissou');

        var _experienceZissou2 = _interopRequireDefault(_experienceZissou);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                _tabs2.default.init();
                _reviews2.default.init();
                _videos2.default.init();
                _experienceZissou2.default.init();
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./_experience-zissou": 15, "./_reviews": 16, "./_tabs": 17, "./_videos": 18 }],
    20: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.default = {
            page: {
                aboutUs: {
                    slidesItems: $('.js--page-about-us-slides-items')
                }
            }
        };

    }, {}],
    21: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._slides();
            },
            _slides: function _slides() {
                var El = _cacheSelectors2.default.page.aboutUs;

                El.slidesItems.slick({
                    dots: true,
                    arrows: false,
                    customPaging: function customPaging(slide, i) {
                        var name = $(slide.$slides[i]).find('.js--page-about-us-slides-slick').data('slides-name');
                        return '<span class="x-page-about-us__slides-name">' + name + '</span>';
                    }
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 20 }],
    22: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var Methods = {
            init: function init() {
                Methods._clickDown();
                Methods._clickMap();
            },
            _clickDown: function _clickDown() {
                $('.x-page-zissou-house__banner .x-banner__icon-see-more').click(function(e) {
                    $("html, body").animate({ scrollTop: $('#shopify-section-page-zissou-house__map').offset().top - 45 }, 1000);
                });
            },
            _clickMap: function _clickMap() {
                var _map = $('.x-page-zissou-house__iframe-map');
                var _360 = $('.x-page-zissou-house__iframe-360');

                $('.x-section-click strong').click(function(event) {

                    var _element = $(this);

                    if (_element.hasClass('e-active')) {
                        _element.text('Faça o Tour 360');
                        _element.removeClass('e-active');
                        _360.toggle();
                        _map.toggle();
                    } else if ($("body").width() <= 768) {
                        window.location.href = "https://www.google.com.br/maps/@-23.5608187,-46.6702145,3a,84.9y,143.34h,90.01t/data=!3m6!1e1!3m4!1sAF1QipOdiD4UypK1kbcS_M8XwDaqRh4IZL3VsDxjgTxI!2e10!7i10240!8i5120";
                    } else {
                        _element.text('Ver no Mapa');
                        _element.addClass('e-active');
                        _360.toggle();
                        _map.toggle();
                    };
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, {}],
    23: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _aboutUs = require('./_about-us.js');

        var _aboutUs2 = _interopRequireDefault(_aboutUs);

        var _zissouHouse__map = require('./_zissou-house__map.js');

        var _zissouHouse__map2 = _interopRequireDefault(_zissouHouse__map);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                _aboutUs2.default.init();
                _zissouHouse__map2.default.init();
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./_about-us.js": 21, "./_zissou-house__map.js": 22 }],
    24: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.default = {
            product: {
                actions: {
                    btn: $('.js--product-actions-btn'),
                    productIcons: $('.js--product-icon'),
                    iconLink: $('.js--product-icon-link'),
                    actionInfo: $('.js--product-action-info'),
                    links: $('.js--action-links'),
                    mainInfo: $('.js--product-main-info'),
                    actionBtn: $('.js--product-action-btn'),
                    infoLeft: $('.js--product-info-left'),
                    infoRight: $('.js--product-info-right'),
                    infoItems: $('.js--product-section-info-items'),
                    infoDescription: $('.js--product-action-info-description'),
                    infoLink: $('.js--product-action-info-link')
                },
                slides: {
                    items: $('.js--product-slides-items'),
                    reviews: $(".spr-reviews")
                },
                img: {
                    items: $('.js--product-img-items'),
                    nav: $('.js--product-img-items--nav')
                },
                accordion: {
                    items: $('.js--product-accordion-items'),
                    title: $('.js--product-accordion-title'),
                    container: $('.js--product-composition-container'),
                    img: $('.js--product-composition-img')
                },
                tab: {
                    content: $('.js--product-production-tab-content'),
                    link: $('.js--product-production-tab-link'),
                    links: $('.js--product-production-tab-links'),
                    img: $('.js--product-production-img')
                },
                reviews: {
                    container: $('.js--product-reviews')
                }
            }
        };

    }, {}],
    25: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._compositionAccordion();
                Methods._setImg();
                Methods._trialAccordion();
                Methods._productInfoAccordion();
            },
            _compositionAccordion: function _compositionAccordion() {
                var paddingTop = 56;
                var El = _cacheSelectors2.default.product.accordion;

                El.items.on('click', '.js--product-accordion-title', function(ev) {
                    var containerTop = El.container.offset().top - paddingTop;
                    var $this = $(ev.currentTarget);
                    var i = $this.closest('.js--product-composition-accordion-item').index() + 1;

                    El.img.find('img').removeClass('is--active').eq(i).addClass('is--active');

                    $this.toggleClass('is--active').next().slideToggle();

                    $this.parent().siblings().children('.js--product-accordion-title').removeClass('is--active').next().slideUp();

                    if (!El.title.hasClass('is--active')) {
                        Methods._setImg();
                    }

                    if (Theme.mobileDevice()) {
                        $('html, body').animate({ scrollTop: containerTop }, 500);
                    }
                });
            },
            _setImg: function _setImg() {
                _cacheSelectors2.default.product.accordion.img.find('img').removeClass('is--active').eq(0).addClass('is--active');
            },
            _trialAccordion: function _trialAccordion() {
                var _click = $('.js--trial-open');
                var _close = $('.js--trial-close');
                _click.click(function(e) {
                    e.preventDefault();
                    return window.location.href = 'https://www.zissou.com.br/pages/retomadas'
                    _click.slideToggle();
                    $('.js--trial-content').slideToggle();
                });

                _close.click(function() {
                    _click.trigger('click');
                });
            },
            _productInfoAccordion: function _productInfoAccordion() {
                var _click = $('.js--accordion-title');
                var _content = $('.js--accordion-content');
                var tabBgUrl = null;
                tabBgUrl = $('.e-product-info__accordion').find('[accordion-default-bg] img').attr('src') || $('.e-product-info__accordion').find('[accordion-default-bg] img').attr('data-src');;
                if(tabBgUrl){
                    $('.e-product-info__accordion').closest('[accordion-bg-target]').addClass('has--background')
                } else {
                    $('.e-product-info__accordion').closest('[accordion-bg-target]').removeClass('has--background')
                }
                _click.click(function() {
                    if (!$(this).hasClass('is--active')) {
                        var tab = $(this);
                        var content =  $(this).siblings('.js--accordion-content');
                        var tabBgUrl = null;
                        var tabBgUrl = $(content).find('[accordion-bg] img').attr('src') || $(content).find('[accordion-bg] img').attr('data-src');;
                        
                        _click.removeClass('is--active');
                        _content.slideUp();
                        $(this).addClass('is--active');
                        $(this).next(_content).slideDown();
             
                        if(tabBgUrl){
                            $(tab).closest('[accordion-bg-target]').addClass('has--background')
                        } else {
                            $(tab).closest('[accordion-bg-target]').removeClass('has--background')
                        }
                    } else {
                        $(this).removeClass('is--active');
                        $(this).next(_content).slideUp();
                    }
                    setTimeout(function() {
                        $('.js--lazy').lazy({
                            enableThrottle: true,
                            effect: 'fadeIn', effectTime: 500,
                            visibleOnly: true,
                            throttle: 100
                        });
                    }, 500);
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    26: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods.detachSkuInfo();
                //Methods.slickHowWorks();
                Methods.informationTech();
            },
            detachSkuInfo: function detachSkuInfo() {
                if (Theme.tabletDevice()) {
                    var $infos = $('.js--product-info-right').eq(1).detach();
                    $('.js--action-links').eq(1).after($infos);
                }
            },
            slickHowWorks: function slickHowWorks() {
                if (Theme.mobileDevice()) $('.x-product__how-works-items').slick();
            },
            informationTech: function informationTech() {
                if ($(window).width() < 768) {
                    $('.e-product-info__tabs .e-product-info__header').after($('.e-product-info__image'));
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    27: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._openDropProduct();
                Methods._setDescriptions();
                Methods._fixedButtoMobile();
                Methods._closeModal();
                Methods.showProductInfoOnClick();
                Methods._travesseiroParallax();
                Methods.colchaoIdeal();
                Methods.activeProductVariation();
                Methods.scrollInfoProduct();
                // Methods.buildDropdownSkuSelector();
                // Methods.buildQuantitySkuSelector();

                // Methods._setDynamicWidths();
                // Methods._fixedButton();
            },
            _closeModal: function _closeModal() {
                $('.e-modal .e-close').click(function() {
                    $('.e-modal').fadeOut();
                });

                $('.e-modal-stockout .e-close').click(function() {
                    $('.e-modal-stockout').fadeOut();
                });
            },
            _openDropProduct: function _openDropProduct() {
                var El = _cacheSelectors2.default.product.actions;

                El.mainInfo.on('click', function(ev) {
                    var $this = $(ev.currentTarget);

                    $this.toggleClass('is--active');
                    // El.actionInfo.slideToggle();
                    if (!El.actionInfo.hasClass('df')) {
                        El.actionInfo.css('display', 'flex').addClass('df');
                    } else {
                        El.actionInfo.css('display', 'none').removeClass('df');
                    }
                });

                El.actionInfo.on('click', 'a', function(ev) {
                    // El.actionInfo.slideUp();
                    El.actionInfo.css('display', 'none');
                });

                El.infoLink.on('click', function(ev) {
                    El.mainInfo.removeClass('is--active');
                });
            },
            _setDescriptions: function _setDescriptions() {
                var El = _cacheSelectors2.default.product.actions;
                var eventType;

                if (Theme.mobileDevice()) {
                    eventType = 'click';
                } else {
                    eventType = 'mouseenter';
                }

                El.infoItems.on(eventType, 'a', function(ev) {
                    var element = $(ev.currentTarget).data('product-section-sku');

                    El.infoDescription.children().removeClass('is--active');
                    El.infoDescription.children().map(function(i, item) {
                        if (element === $(item).data('info-description-sku')) {
                            $(item).addClass('is--active');
                        }
                    });
                });

                El.infoItems.on('mouseleave', function(ev) {
                    El.infoDescription.children().removeClass('is--active');
                    El.infoDescription.children().eq(0).addClass('is--active');
                });
            },


            _fixedButtoMobile: function _fixedButtoMobile() {
                if ($('body').hasClass('template-product') && meta.product.type == 'Travesseiro') {
                    var _topButton = $(window).height() + 450;
                    var _limitBottom = $(document).height() - $(window).height();
                    $(window).scroll(function() {
                        var _scrollTop = $(window).scrollTop();
                        if (_scrollTop < _limitBottom) {

                            if (_scrollTop >= _topButton) {
                                $('.x-product__action-btn, .x-product__main-info, .x-product__action-info-installment, .x-product__action-info').addClass('x-active');
                            } else {
                                $('.x-product__action-btn, .x-product__main-info, .x-product__action-info-installment, .x-product__action-info').removeClass('x-active');
                            }
                        } else {
                            $('.x-product__action-btn, .x-product__main-info, .x-product__action-info-installment, .x-product__action-info').removeClass('x-active');
                        }
                    });
                }
            },

            showProductInfoOnClick: function showProductInfoOnClick() {
                var _document = $(document);
                var _click = $('.js--product-action-info-link');
                var _productSkuDropdownList = $('.productSkuDropdown--Wrapper .productSkuDropdown--List');

                _click.click(function() {

                    $('.js--product-action-info-link .e-product-skus-icons, .e-product-skus-item').removeClass('e-selected');
                    $('.skus-wrapper-total').addClass('e-active');
                    var variantOBJ = !!$(this).attr('data-variant-object')? JSON.parse($(this).attr('data-variant-object').replace(/'/g,'"')):null
                    if(variantOBJ){
                        $(this).find('.e-product-skus-icons').addClass('e-selected');
                        $(this).parents('.e-product-skus-item, .skus-wrapper').addClass('e-selected');
                    } else{
                        $(document).find('.e-product-skus-icons').removeClass('e-selected');
                        $(document).parents('.e-product-skus-item, .skus-wrapper').removeClass('e-selected');
                    }
                    // _globalComponents.setVariantInfos(variantOBJ)

                    // var _barcode = $(this).attr('data-product-section-barcode');
                    // var _title = $(this).attr('data-product-section-title');
                    // var _size = $(this).attr('data-product-section-size');
                    // var _variantPrice = $(this).attr('data-product-price').replace('R$', '').replace('.', '').replace(',', '').replace(' ', '');
                    // var _productTotalPrice = ProductJS.variantSelected._store.reduce(function(prev, cur){
                    //     return prev + cur.price
                    // },0)
                    // var _inventory = $(this).attr('data-product-section-inventory');
                    // var _description = $(this).attr('data-product-section-description');
                    // var _variantID = $(this).attr('data-variant-id');
                    // var _installmentOBJ = _globalComponents.getInstallmentInfos(parseInt(_productTotalPrice), 12);

                    // $(this).find('.e-product-skus-icons').addClass('e-selected');
                    // // debugger;
                    // $('.js--selected-barcode').html(_barcode);
                    // $('.js--selected-title').html(_title);
                    // $('.js--selected-size').html(_size);
                    // $('.js--selected-total').html(Shopify.formatMoney(_productTotalPrice));
                    // $('.js--selected-inventory').html(_inventory);
                    // $('.js--selected-description').html(_description);
                    // $('.js--selected-installment-qty').html((_installmentOBJ.installments) + 'x');
                    // $('.js--selected-installment-amount').html(Shopify.formatMoney(_installmentOBJ.installmentAmount));
                    // $('.js--selected-installment-total-amount').html(Shopify.formatMoney(_installmentOBJ.installmentTotalAmount));
                    // $('.js--selected-installment-total-tax').html(((_installmentOBJ.installmentTax * 100).toFixed(2)) + '%');

                    // $('#product-select').val(variantOBJ.id)
                    $(document).trigger("ProductInfoChanged", [$(this)]);
                });

                _document.on("ProductInfoChanged", function() {
                    var _productSkuObservations = $('.js--selected-barcode');
                    if(_productSkuObservations.length > 0){
                        gsap.fromTo(_productSkuObservations, .5, {
                            y: 25,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            stagger: .25
                        });
                    }
                });
            },

            _travesseiroParallax: function _travesseiroParallax() {

                window.addEventListener("load", MagicScroll);

                function MagicScroll() {
                    var controller = new ScrollMagic.Controller();

                    new ScrollMagic.Scene({
                        triggerElement: ".e-product-perfect__contents",
                        offset: 200
                    }).setClassToggle(".e-product-perfect__item", "e-active").addTo(controller);

                    new ScrollMagic.Scene({
                        triggerElement: ".e-product-zissou-ideal__gallery--item-movie",
                        offset: 120
                    }).setClassToggle(".e-product-zissou-ideal__gallery--item-movie", "e-disable").addTo(controller);
                }
            },


            colchaoIdeal: function colchaoIdeal() {
                var btn_colchao = $('.e-product-zissou-ideal__gallery .e-bullets .e-bullets-btn');
                var product_colchao = $('.e-product-zissou-ideal__gallery--item');

                btn_colchao.click(function() {
                    var index = btn_colchao.index(this);
                    console.log('index', index);

                    btn_colchao.removeClass('e-active');
                    product_colchao.removeClass('e-active');

                    btn_colchao.eq(index).addClass('e-active');
                    product_colchao.eq(index).addClass('e-active');

                    $('.e-product-zissou-ideal__gallery--movie').addClass('e-disable');
                    $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100, effectTime: 400, effect: 'fadeIn' });
                    // descer tela
                    setTimeout(function() {
                        console.log('setTimeout');
                        $('html,body').animate({ scrollTop: $('.e-product-zissou-ideal__gallery--item.e-active .e-product-zissou-ideal__gallery--item-text').offset().top - 350 }, 800);
                    }, 250);


                });

                // next colchao
                $('.e-product-zissou-ideal__gallery .e-item-arrow__button.e-arrow-next').click(function() {
                    if ($('.e-product-zissou-ideal__gallery .e-bullets .e-bullets-btn.e-active').length) {
                        $('.e-product-zissou-ideal__gallery .e-bullets .e-bullets-btn.e-active').next().click();
                    } else {
                        $('.e-product-zissou-ideal__gallery .e-bullets .e-bullets-btn').eq(0).click();
                    }
                });

                // prev colchao
                $('.e-product-zissou-ideal__gallery .e-item-arrow__button.e-arrow-prev').click(function() {
                    $('.e-product-zissou-ideal__gallery .e-bullets .e-bullets-btn.e-active').prev().click();
                });
            },
            activeProductVariation: function activeProductVariation() {
                $(document).ready(function() {
                    if ($('body').hasClass('template-product')) {
                        if (meta.product.type == 'Colchão') {
                            $('.x-product .e-product-info .e-info-actions .e-product-skus__list .skus-wrapper li').eq(3).find('a').trigger('click');
                        } else if (meta.product.type == 'Toca') {
                            $('.x-product .e-product-info .e-info-actions .e-product-skus__list .skus-wrapper li').eq(0).find('a').trigger('click');
                        } else if (meta.product.type == 'Jogo de Lençol') {
                            $('.x-product .e-product-info .e-info-actions .e-product-skus__list .skus-wrapper li').eq(3).find('[data-variant], [data-change-option]').trigger('click');
                        } else{
                            $('.x-product .e-product-info .e-info-actions .e-product-skus__list .skus-wrapper li').eq(0).find('[data-variant], [data-change-option]').trigger('click');
                        }
                    }
                })
            },

            scrollInfoProduct: function scrollInfoProduct() {
                $(function() {

                    var scroll_pos = $(document).scrollTop();
                    if (scroll_pos >= 0 && scroll_pos <= 400) {
                        setTimeout(function() {
                            if ($(window).width() > 1080 && $(".x-product__section").length > 0) {
                                var scrollTarget = $(".x-product__section")
                                if($('.campaign.promo_banner').length > 0){
                                    scrollTarget = $('.campaign.promo_banner')
                                }
                                $('html, body').animate({
                                    scrollTop: scrollTarget.offset().top - 50
                                }, 900)
                            }
                        }, 3000);
                    }
                })

                $('body').on('click', '.e-main-banner__arrow', function(event) {
                    if ($(window).width() > 1080) {
                        var scrollTarget = $(".x-product__section")
                        if($('.campaign.promo_banner').length > 0){
                            scrollTarget = $('.campaign.promo_banner')
                        }
                        $('html, body').animate({
                            scrollTop: scrollTarget.offset().top - 50
                        }, 900);
                    }
                });
                $('body').on('click', '[go-to-coversion]', function(event) {
                    event.preventDefault();
                    setTimeout(() => {
                        if($(".product__selector").length){
                            return $('html, body').animate({
                                scrollTop: $(".product__selector").offset().top - 50
                                // scrollTop: 443
                            }, 900);
                        }
                        $('html, body').animate({
                            // scrollTop: $(".x-product__section").offset().top - 50
                            scrollTop: 443
                        }, 900);
                    }, 500);
                });
                $('body').on('click', '[go-to-product-qa]', function(event) {
                    event.preventDefault();
                    setTimeout(() => {
                        if($(".product__qa").length){
                            return $('html, body').animate({
                                scrollTop: $(".product__qa").offset().top - 50
                                // scrollTop: 443
                            }, 900);
                        }
                        $('html, body').animate({
                            // scrollTop: $(".x-product__section").offset().top - 50
                            scrollTop: 443
                        }, 900);
                    }, 500);
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    28: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._productSlide();
                Methods.productThumbs();
                Methods.baseIcons();
                Methods._infoSlide();
            },
             
baseIcons: function(){
                if(window.location.href.includes("base-zissou")){
                 console.log("rodou a func")

                 setTimeout(function(){

    $(".e-product-skus-link").each(function(){
 
 let variant = $(this).find(".variantTitle").text();
 if(variant === "Solteiro"){
   $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/solteiro.png?v=1640064588' />")
 }

 if(variant === "Solteiro Especial"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/solteiro-especial.png?v=1640064519' />")
 }


 if(variant === "Casal"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/casal.png?v=1640064549' />")
 }


 if(variant === "Queen"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/queen.png?v=1640064519' />")
 }


 if(variant === "King" || variant === "King BR"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/kingbr.png?v=1640064563' />")
 }


 if(variant === "Par de Fronhas" || variant === "Fronha Avulsa"){
     $(this).parent().parent().remove() 

 }

})

                 }, 3000) 


                     $(".e-product-skus-link, .x-product__action-info-item").on("click", function(){

                     setTimeout(function(){
    $(".e-product-skus-link").each(function(){
 
 let variant = $(this).find(".variantTitle").text();
 if(variant === "Solteiro"){
   $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/solteiro.png?v=1640064588' />")
 }

 if(variant === "Solteiro Especial"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/solteiro-especial.png?v=1640064519' />")
 }


 if(variant === "Casal"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/casal.png?v=1640064549' />")
 }


 if(variant === "Queen"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/queen.png?v=1640064519' />")
 }


 if(variant === "King" || variant === "King BR"){
     $(this).parent().find(".e-product-skus-icons").html("<img src='https://cdn.shopify.com/s/files/1/1526/6199/files/kingbr.png?v=1640064563' />")
 }


})}, 1000)


                     })
                      }

            },
            _productSlide: function _productSlide() {
                var nextArrowSVG = '<button type="button" class="slick-next"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M24.56,841.89c-4.46,0-8.97-1.21-13.03-3.75c-11.51-7.21-14.99-22.38-7.78-33.89l240.12-383.3L3.75,37.64 c-7.21-11.5-3.72-26.68,7.78-33.89c11.5-7.21,26.68-3.72,33.89,7.78l247.37,394.88c2.45,3.91,3.75,8.43,3.75,13.05v2.96 c0,4.62-1.3,9.14-3.75,13.05L45.42,830.35C40.75,837.8,32.75,841.89,24.56,841.89z"/> </g> </svg></button>';
                var prevArrowSVG = '<button type="button" class="slick-prev"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M271.98,0c4.46,0,8.97,1.21,13.03,3.75c11.51,7.21,14.99,22.38,7.78,33.89L52.67,420.94l240.12,383.31 c7.21,11.5,3.72,26.68-7.78,33.89c-11.5,7.21-26.68,3.72-33.89-7.78L3.75,435.47C1.3,431.56,0,427.04,0,422.42v-2.96 c0-4.62,1.3-9.14,3.75-13.05L251.12,11.54C255.79,4.09,263.79,0,271.98,0z"/> </g> </svg></button>';
                // js--product-img-items
                // js--product-img-items--nav
                var mattressArray = [
                    "colchao-zissou",
                    "colchao-zissou-coral",
                    "base-zissou",
                    "colchao-zissou-coral-original",
                    "colchao-zissou-coral-hibrido",
                    "colchao-zissou-blue"
                ];
                var prodHandle = window.location.pathname.split('products/')[1];

                if(!!$('.js--product-img-items--nav').length){
                    _cacheSelectors2.default.product.img.nav.slick({
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        asNavFor: '.js--product-img-items',
                        centerMode: false,
                        focusOnSelect: true,
                        prevArrow: prevArrowSVG,
                        nextArrow: nextArrowSVG,
                        arrows: false,
                        dots: false
                    });

                }
                _cacheSelectors2.default.product.img.items.slick({
                    infinite: true,
                    fade: true,
                    asNavFor: !!$('.js--product-img-items--nav').length ? '.js--product-img-items--nav' : null,
                    prevArrow: prevArrowSVG,
                    nextArrow: nextArrowSVG,
                    dots: mattressArray.includes(prodHandle) ? true : false
                });
                if(window.outerWidth >= 1024){
                    _cacheSelectors2.default.product.img.items.slick('slickFilter', function(slide){
                        return slide > 0
                    })
                } else {
                    _cacheSelectors2.default.product.img.items.slick('slickUnfilter')
                }
                _cacheSelectors2.default.product.img.items.on('swipe init lazyLoaded afterChange', function(event, slick, currentSlide) {
                    var _this = $(this);
                    var _currentSlide = currentSlide;
                    var $activeSlide = _this.find('.slick-slide')[currentSlide];
                    var lightness;

                    _globalComponents.getImageLightness($($activeSlide).find('img').attr('data-image'), function(brightness) {
                        lightness = brightness;
                        console.log(lightness);
                        lightness > 150 ? $(_this).siblings('.e-main-banner__title').attr('color-mode', 'light') : $(_this).siblings('.e-main-banner__title').attr('color-mode', 'dark');
                    });
                    setTimeout(function() {
                        $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100 });
                    }, 150);

                });
            },
            
            productThumbs: function productThumbs() {
                // console.log('teste');
                var nextArrowSVG = '<button type="button" class="slick-next"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M24.56,841.89c-4.46,0-8.97-1.21-13.03-3.75c-11.51-7.21-14.99-22.38-7.78-33.89l240.12-383.3L3.75,37.64 c-7.21-11.5-3.72-26.68,7.78-33.89c11.5-7.21,26.68-3.72,33.89,7.78l247.37,394.88c2.45,3.91,3.75,8.43,3.75,13.05v2.96 c0,4.62-1.3,9.14-3.75,13.05L45.42,830.35C40.75,837.8,32.75,841.89,24.56,841.89z"/> </g> </svg></button>';
                var prevArrowSVG = '<button type="button" class="slick-prev"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M271.98,0c4.46,0,8.97,1.21,13.03,3.75c11.51,7.21,14.99,22.38,7.78,33.89L52.67,420.94l240.12,383.31 c7.21,11.5,3.72,26.68-7.78,33.89c-11.5,7.21-26.68,3.72-33.89-7.78L3.75,435.47C1.3,431.56,0,427.04,0,422.42v-2.96 c0-4.62,1.3-9.14,3.75-13.05L251.12,11.54C255.79,4.09,263.79,0,271.98,0z"/> </g> </svg></button>';

                var _slider = $('.e-product-main__images .js--product-img-items');
                var _options = {
                    lazyLoad: 'ondemand',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    cssEase: 'linear',
                    autoplay: false,
                    infinite: true,
                    arrows: true,
                    prevArrow: prevArrowSVG,
                    nextArrow: nextArrowSVG,
                    dots: false
                };
                _slider.slick(_options);

            },
            _infoSlide: function _infoSlide() {
                _cacheSelectors2.default.product.slides.items.slick({
                    dots: false,
                    fade: true,
                    responsive: [{
                        breakpoint: Theme.mobileScreen,
                        settings: {
                            adaptiveHeight: true
                        }
                    }]
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    29: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._consultIntelipost();
            },


            // _cepCalculation (){
            //   $(".x-product__shipping-calculate__form .e-cep").mask("99999-999");
            // },

            _getCartViaAJAX: function _getCartViaAJAX() {

            },
            _clearTestProductToCalculateShipping: function _clearTestProductToCalculateShipping(callback) {
                jQuery.post('/cart/clear.js', {}).success(function() {
                    console.log('Cart Cleared');
                });
            },
            _addTestProductToCalculateShipping: function _addTestProductToCalculateShipping(callback) {
                jQuery.post('/cart/add.json', {
                    quantity: 1,
                    id: 13647700361289,
                    properties: {
                        'shipping': 'Test'
                    }
                }).done(function() {
                    callback();
                });
            },
            _consultShippingRates: function _consultShippingRates(cep, clear) {
                var settings = {
                    "async": true,
                    "crossDomain": true,
                    "url": "/cart/shipping_rates.json?shipping_address[zip]=" + cep + "&shipping_address[country]=Brazil&shipping_address[province]=S%C3%A3o%20Paulo",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "cache-control": "no-cache",
                        "Postman-Token": "0e466b40-4da8-4270-8ff6-4551d23df5fd"
                    },
                    "processData": false,
                    "data": ""
                }

                $.ajax(settings).done(function(response) {
                    console.log(response.shipping_rates);
                    var shippingRate = response.shipping_rates[0];

                    var diaAnt = shippingRate.delivery_days[0] - 2;
                    var diaPos = shippingRate.delivery_days[1] + 0;

                    CartJS.buildShippingRates(ProductJS.variantSelected._store.id, [diaAnt, diaPos]).then(function(shippingRate){
                        $('.x-product__shipping-calculate h3').text(shippingRate.trim());
                    })

                    if (clear !== undefined) {
                        Methods._clearTestProductToCalculateShipping();
                    }
                }).error(function() {
                    $('.x-product__shipping-calculate h3').html("Ainda não entregamos para o CEP informado<br> pelo site, por favor envie um e-mail para<br> <a href=\"mailto:zzz@zissou.com.br\">zzz@zissou.com.br</a> que retornaremos com <br>mais informações.");
                });
            },
            _consultIntelipost: function _consultIntelipost() {
                $(document).on('click', '.x-product__shipping-calculate__form .e-button-cep', function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var cep = $(ev.currentTarget).parents('.e-product-shipping').find('.x-product__shipping-calculate__form .e-cep').val().replace(/[\.\-]/g, '');
                    if (cep.length < 8) {
                        $('.x-product__shipping-calculate h3').html("Ops, você deve ter digitado o seu CEP de maneira incorreta. Revise e clique em \"Calcular\" novamente. Se a mensagem de erro persistir, por favor <a href='javascript: void(0)' onclick=\"window.open('mailto:falecom@zissou.com.br');\" class='x-help-menu__chat-link'>clique aqui</a> para nos enviar uma mensagem. ");
                    } else {
                        CartJS.getCart({showCartOnComplete: false})
                        .then(function(cart){
                            console.log(cart);
                            if (cart.items.length > 0) {
                                Methods._consultShippingRates(cep);
                            } else {
                                Methods._addTestProductToCalculateShipping(function() { Methods._consultShippingRates(cep, true) });
                            }
                        });
                    }
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    30: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._fixedHeader();
            },
            _fixedHeader: function _fixedHeader() {
                if ($('body').hasClass('template-product')) {
                    var _scroll = 0;
                    $(window).on('scroll', function(ev) {
                        if (ev.currentTarget.pageYOffset > _scroll && $(window).width() > 770) {
                            $('.e-main-header-product, #shopify-section-header').addClass('is--one');
                        } else {
                            $('.e-main-header-product, #shopify-section-header').removeClass('is--one');
                        }

                        _scroll = ev.currentTarget.pageYOffset;

                        var _offsetTop = $(window).width() > 770 ? $('.e-footer').offset().top : $('.e-footer').offset().top;
                        // if ($(window).scrollTop() + $(window).height() < _offsetTop) {
                        if (ev.currentTarget.pageYOffset > $(window).height() * 1 && $(window).scrollTop() + $(window).height() < _offsetTop) {
                            $('.e-main-header-product').addClass('is--active');
                            $('.widget__floating-bar').addClass('is--active');
                            $('body').addClass('miniCartShown');
                        } else {
                            $('.e-main-header-product').removeClass('is--active');
                            $('.widget__floating-bar').removeClass('is--active');
                            $('body').removeClass('miniCartShown');
                        }
                    });
                }
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    31: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods.sliderPlugin();
                Methods.sliderPluginMobile();
                Methods.reviewsDown();
            },
            sliderPlugin: function sliderPlugin() {
                $('.e-marcas-plugin .e-table-reviews ul').slick({
                    dots: false,
                    arrows: false,
                    fade: true,
                    infinite: true,
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 4000
                });
            },
            sliderPluginMobile: function sliderPluginMobile() {
                $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks ul').slick({
                    dots: false,
                    arrows: true,
                    fade: true,
                    infinite: true,
                    speed: 1000,
                    autoplay: false,
                    autoplaySpeed: 4000,
                    adaptiveHeight: true
                });
            },
            reviewsDown: function reviewsDown() {
                $('.e-marcas-plugin-mobile .e-table-reviews .select').click(function(e) {
                    $(this).toggleClass('e-active');
                    $('.e-select ul').toggleClass('e-active');
                    $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks').toggleClass('e-active');
                });
                $('.e-marcas-plugin-mobile .e-table-reviews .e-select li').click(function(e) {
                    var _class = $(this).attr('data-class');
                    var _text = $(this).text();

                    $('.e-select ul').toggleClass('e-active');
                    $('.e-marcas-plugin-mobile .e-table-reviews .select').toggleClass('e-active');
                    $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks').toggleClass('e-active');

                    $('.e-marcas-plugin-mobile .e-table-reviews .select').text(_text);
                    $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks .e-block').addClass('e-hide');
                    $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks .e-block').removeClass('e-active');
                    $('.e-marcas-plugin-mobile .e-table-reviews .e-content-blocks .e-block.' + _class).addClass('e-active');
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    32: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods._getProductInfo();
                Methods.getSelectSku();
                // Methods._getProductSku();
            },
            _getProductInfo: function _getProductInfo() {
                var El = _cacheSelectors2.default.product.actions;
                var ProductInfo = Shopify.theme.zissou.product || '';
                var name = ProductInfo !== '' ? ProductInfo.tags[1] : '';
                var price = Shopify.theme.zissou.price || '';
                // const markupSku = `
                //     <span class="x-product__main-name">${name}</span>
                //     <span class="x-product__main-separator">-</span>
                //     <span class="x-product__main-price">${price}</span>
                // `;

                if (name === "" && window.location.href.indexOf('variant') < 0) {
                    El.mainInfo.html('<span class="x-product__main-name">SELECIONE</span>');
                    return true;
                }

                //El.mainInfo.append(markupSku);
            },
            _getProductSku: function _getProductSku() {
                var El = _cacheSelectors2.default.product.actions;

                $.ajax({
                    url: '/products.json',
                    type: 'GET'
                }).then(function(response) {
                    var handle = [];
                    var title = [];
                    var description = [];
                    var price = [];
                    var tags = [];
                    var markupList = '';
                    var markupDescription = '';

                    response.products.map(function(product) {
                        handle.push(product.handle);
                        title.push(product.title);
                        description.push(product.body_html);
                        price.push(product.variants[0].price);
                        tags.push(product.tags);
                    });

                    handle.map(function(item, i) {
                        if (tags[i][1] !== undefined) {
                            markupList += '\n                        <li class="x-product__action-info-item">\n                            <a href="' + handle[i] + '" class="x-product__action-info-link">' + tags[i][1] + '<span>(' + tags[i][0] + ')</span></a>\n                        </li>\n                    ';

                            markupDescription += '\n                        <div id="' + handle[i] + '" class="x-product__action-info-description-item">' + description[i] + '</div>\n                    ';
                        }
                    });

                    El.infoItems.append(markupList);
                    El.infoDescription.append(markupDescription);
                });
            },
            getSelectSku: function getSelectSku() {
                $(document).on('click', '.e-product-skus__list .skus-wrapper li', function() {
                    // var text_variation = $(this).find('.e-product-skus-link p').text();
                    // $('.e-product-skus__list .skus-wrapper-total>div.e-dimension h3').html(text_variation);

                    // if (meta.product.type == 'Colchão') {} 
                    // else if (meta.product.type == 'Toca') {} 
                    // else if (meta.product.type == 'Jogo de Lençol') {
                    //   text_variation = $(this).find('.e-product-skus-link > *').html();
                    //   $('.e-product-skus__list .productSkuDropdown--Current .e-product-skus-item .e-product-skus-link-wrapper .variantTitle').html(text_variation);
                    // }

                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    33: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _cacheSelectors = require('./__cache-selectors.js');

        var _cacheSelectors2 = _interopRequireDefault(_cacheSelectors);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                Methods.productionTabs();
                Methods.setInitialImgSrc();
                Methods.productSpecificationDropdown();
            },
            productionTabs: function productionTabs() {
                var El = _cacheSelectors2.default.product.tab;

                El.link.eq(0).add(El.content.eq(0)).addClass('is--active');
                El.links.on('click', 'a', function(ev) {
                    ev.preventDefault();

                    var $this = $(ev.currentTarget);
                    var i = $this.index();

                    $this.add(El.content.eq(i)).addClass('is--active').siblings().removeClass('is--active');

                    var imgSrc = El.content.eq(i).children('.js--product-production-img-src').data('img-src');
                    El.img.attr('src', imgSrc);
                });
            },
            setInitialImgSrc: function setInitialImgSrc() {
                var El = _cacheSelectors2.default.product.tab;
                var imgSrc = '';

                El.content.map(function(i, item) {
                    if ($(item).hasClass('is--active')) {
                        imgSrc = $(item).children('.js--product-production-img-src').data('img-src');
                    }
                });

                El.img.attr('src', imgSrc);
            },
            productSpecificationDropdown: function productSpecificationDropdown() {
                var _title = $('.js--specification-open');
                $('.e-product-specification__contents--item-image').eq(0).show();
                _title.click(function() {
                    var _attr = $(this).attr('data-image');
                    if (!$(this).hasClass('e-active')) {
                        $('.js--specification-open').removeClass('e-active');
                        $('.js--specification').slideUp();
                        $(this).addClass('e-active');
                        $(this).next('.js--specification').slideDown();
                        $('.e-product-specification__contents--item-image').hide();
                        $('#' + _attr).fadeIn();
                    } else {
                        $(this).removeClass('e-active');
                        $(this).next('.js--specification').slideUp();
                    }
                });
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./__cache-selectors.js": 24 }],
    34: [function(require, module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _headerProduct = require('./_header-product');

        var _headerProduct2 = _interopRequireDefault(_headerProduct);

        var _carrousels = require('./_carrousels');

        var _carrousels2 = _interopRequireDefault(_carrousels);

        var _accordions = require('./_accordions');

        var _accordions2 = _interopRequireDefault(_accordions);

        var _pluginReview = require('./_plugin-review');

        var _pluginReview2 = _interopRequireDefault(_pluginReview);

        var _tabs = require('./_tabs');

        var _tabs2 = _interopRequireDefault(_tabs);

        var _actions = require('./_actions');

        var _actions2 = _interopRequireDefault(_actions);

        var _skusProducts = require('./_skusProducts');

        var _skusProducts2 = _interopRequireDefault(_skusProducts);

        var _actionsMobile = require('./_actions-mobile');

        var _actionsMobile2 = _interopRequireDefault(_actionsMobile);

        var _frete = require('./_frete');

        var _frete2 = _interopRequireDefault(_frete);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        var Methods = {
            init: function init() {
                _headerProduct2.default.init();
                _carrousels2.default.init();
                _accordions2.default.init();
                _pluginReview2.default.init();
                _tabs2.default.init();
                _actions2.default.init();
                _skusProducts2.default.init();
                _actionsMobile2.default.init();
                _frete2.default.init();
            }
        };

        exports.default = {
            init: Methods.init
        };

    }, { "./_accordions": 25, "./_actions": 27, "./_actions-mobile": 26, "./_carrousels": 28, "./_frete": 29, "./_header-product": 30, "./_plugin-review": 31, "./_skusProducts": 32, "./_tabs": 33 }],
        35: [function(require, module, exports) {
        'use strict';

        var _index = require('./modules/Geral/index');

        var _index2 = _interopRequireDefault(_index);

        var _index3 = require('./modules/Home/index');

        var _index4 = _interopRequireDefault(_index3);

        var _index5 = require('./modules/Product/index');

        var _index6 = _interopRequireDefault(_index5);

        var _index7 = require('./modules/Page/index');

        var _index8 = _interopRequireDefault(_index7);

        var _index9 = require('./modules/Customers/index');

        var _index10 = _interopRequireDefault(_index9);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        $(function() {
            _index2.default.init();
            _index4.default.init();
            _index6.default.init();
            _index8.default.init();
            _index10.default.init();
        });

    }, { "./modules/Customers/index": 4, "./modules/Geral/index": 13, "./modules/Home/index": 19, "./modules/Page/index": 23, "./modules/Product/index": 34 }]
}, {}, [35]);

$(document).ready(function() {
    $('.selector-wrapper').remove();
    $("#btn-quero-customizar").click(function() {
        $("#modal-personalizado").fadeIn("slow");
        $("#modal-personalizado .modal-content").fadeIn("slow");
    });

    $(".fechar-modal").click(function() {
        $("#modal-personalizado").fadeOut("slow");
    });

    $("#btn-eu-quero").click(function() {
        $(".div2-custom").slideDown("slow");

        $('#modal-personalizado').animate({
            scrollTop: $('.div2-custom').offset().top - 150
        }, 1000);
        $('.js--lazy').lazy();
    });

    $("#btn-nao-quero").click(function() {
        $("#modal-personalizado").fadeOut("slow");
    });

    $("#custom-textarea-modal").keyup(function() {
        var textarea = $(this).val();

        $("textarea.product-options-textarea").val(textarea);
    });


    $(".custom-btn-sugestoes").click(function() {

        var idBtn = $(this).attr('data-id');

        $(".custom-sugestoes-2").removeClass("active");
        $(".custom-sugestoes-4").removeClass("active");

        $(".img-2").removeClass("active");
        $(".img-1").addClass("active");

        $(this).find(".img-1").removeClass("active");
        $(this).find(".img-2").addClass("active");

        $(this).addClass("active");
        var suggestionRadioButton = $(".product-options-radiobutton[value='" + idBtn + "']");

        if ($(this).is(':checked')) {
            $(".product-options-radiobutton[value='" + idBtn + "']").prop("checked", false);
        } else {
            $(".product-options-radiobutton[value='" + idBtn + "']").prop("checked", true);

        }

    });

    $("#btn-seguir-carrinho").click(function() {

        $("#product-select option[value='13647700361289']").prop("selected", false);
        $("#product-select option[value='18247927398473']").prop("selected", true);

        $("#modal-personalizado").fadeOut("slow");
        $("#modal-personalizado .modal-content").fadeOut("slow");
        $(".div2-custom").fadeOut("slow");

        $('#add-to-cart-personalize').trigger('click');

        $("#product-select option[value='13647700361289']").prop("selected", true);
        $("#product-select option[value='18247927398473']").prop("selected", false);

        $('[name="properties[Frases]"],[name="properties[Escreva o texto]"]').attr('checked', false);
        $('.custom-btn-sugestoes').removeClass('active');
    });

    $("#mask-col3").click(function() {
        $(this).removeClass("active");
        $("#mask-col2").addClass("active");

        $("#custom-textarea-modal").val('');
        $("textarea.product-options-textarea").val('');
    });

    $("#mask-col2").click(function() {
        $(this).removeClass("active");
        $("#mask-col3").addClass("active");

        $(".custom-sugestoes-2").removeClass("active");
        $(".custom-sugestoes-4").removeClass("active");

        $(".product-options-radiobutton").prop("checked", false);
    });

    $(document).on('click', '#add-to-cart-personalize, #pre-order', function(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem('btncomprar', true);
        parseInt($('#product-select').val()) == 18247927398473 ? propertiesOBJ = {
            "Escreva o nome": $('[name="properties[Escreva o texto]"]').val(),
            "Frases": $('[name="properties[Frases]"]:checked').val()
        } : propertiesOBJ = {};

        // $('[name="properties"]').val(JSON.stringify(propertiesOBJ));

        $(this).parent().submit();
        // debugger;
        // CartJS.addItem(parseInt($('#product-select').val()), 1, propertiesOBJ, {
        //   "success": function(data, textStatus, jqXHR) {
        //     $('.x-minicart').addClass('is--active');
        //   },
        //   "error": function(jqXHR, textStatus, errorThrown) {
        //         if(textStatus==422){
        //           alert('Produto já foi adicionado em seu carrinho');
        //         }
        //         else{
        //           alert('Erro ao adicionar produto');
        //         }
        //       }
        //   });
    });
    $(document).on('click', '.quickAddDiscountedBlanket', function(e) {
        console.log('quickAddDiscountedBlanket');
        CartJS.addItem(19147467980873, 1, {}, {
            "success": function(data, textStatus, jqXHR) {
                CartJS.getCart();
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                if (textStatus == 422) {
                    alert('Produto já foi adicionado em seu carrinho');
                } else {
                    alert('Erro ao adicionar produto');
                }
            }
        });

    });
    //return false;


    $(document).on('click', '.quickAddDiscountedBlanket', function(e) {
        //CartJS.addItem(19147467980873,1,{});

    });


});

// #region plugin de mask
'use strict';

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function(factory, jQuery, Zepto) {

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function($) {

    var Mask = function(el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function() {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                    .on('keydown.mask', function(e) {
                        el.data('mask-keycode', e.keyCode || e.which);
                        el.data('mask-previus-value', el.val());
                        el.data('mask-previus-caret-pos', p.getCaret());
                        p.maskDigitPosMapOld = p.maskDigitPosMap;
                    })
                    .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                    .on('paste.mask drop.mask', function() {
                        setTimeout(function() {
                            el.keydown().keyup();
                        }, 100);
                    })
                    .on('change.mask', function() {
                        el.data('changed', true);
                    })
                    .on('blur.mask', function() {
                        if (oldValue !== p.val() && !el.data('changed')) {
                            el.trigger('change');
                        }
                        el.data('changed', false);
                    })
                    // it's very important that this callback remains in this position
                    // otherwhise oldValue it's going to work buggy
                    .on('blur.mask', function() {
                        oldValue = p.val();
                    })
                    // select all text on focus
                    .on('focus.mask', function(e) {
                        if (options.selectOnFocus === true) {
                            $(e.target).select();
                        }
                    })
                    // clear the value if it not complete the mask
                    .on('focusout.mask', function() {
                        if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                            p.val('');
                        }
                    });
            },
            getRegexMask: function() {
                var maskChunks = [],
                    translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = { digit: mask.charAt(i), pattern: pattern };
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                        .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function() {
                var oldVal = el.data('mask-previus-value') || '',
                    newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                        caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew]) {
                            var caretPos = caretPosNew;
                            caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                            caretPosNew -= maskDigitsBeforeCaret;
                            if (p.maskDigitPosMap[caretPosNew]) {
                                caretPosNew = caretPos;
                            }
                        }
                    } else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret();

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                        p.setCaret(p.calculateCaretPosition());
                    }, 10);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0,
                    maskLen = mask.length,
                    v = 0,
                    valLen = value.length,
                    offset = 1,
                    addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function() {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function() {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                            if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                            p.invalid.push({ p: v, v: valDigit, e: translation.pattern });
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
                var maskDiff = options.reverse ? newVal.length - valLen : 0;
                p.maskDigitPosMap = {};
                for (var i = 0; i < maskDigitPosArr.length; i++) {
                    p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
                }
            },
            callbacks: function(e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this,
            oldValue = p.val(),
            regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el, options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
            return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
            return p.getMasked(false, val);
        };

        jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys = $.jMaskGlobals.byPassKeys;
            jMask.translation = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder', options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                    el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function() {
            var input = $(this),
                options = {},
                prefix = 'data-mask-',
                mask = input.attr('data-mask');

            if (input.attr(prefix + 'reverse')) {
                options.reverse = true;
            }

            if (input.attr(prefix + 'clearifnotmatch')) {
                options.clearIfNotMatch = true;
            }

            if (input.attr(prefix + 'selectonfocus') === 'true') {
                options.selectOnFocus = true;
            }

            if (notSameMaskObject(input, mask, options)) {
                return input.data('mask', new Mask(this, mask, options));
            }
        },
        notSameMaskObject = function(field, mask, options) {
            options = options || {};
            var maskObject = $(field).data('mask'),
                stringify = JSON.stringify,
                value = $(field).val() || $(field).text();
            try {
                if (typeof mask === 'function') {
                    mask = mask(value);
                }
                return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
            } catch (e) {}
        },
        eventSupported = function(eventName) {
            var el = document.createElement('div'),
                isSupported;

            eventName = 'on' + eventName;
            isSupported = (eventName in el);

            if (!isSupported) {
                el.setAttribute(eventName, 'return;');
                isSupported = typeof el[eventName] === 'function';
            }
            el = null;

            return isSupported;
        };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function() {
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': { pattern: /\d/ },
            '9': { pattern: /\d/, optional: true },
            '#': { pattern: /\d/, recursive: true },
            'A': { pattern: /[a-zA-Z0-9]/ },
            'S': { pattern: /[a-zA-Z]/ }
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));
// #endregion plugin de mask

// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function() {
            supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
} catch (e) {}

$(document).ready(function() {
    $('#btn-nao-quero').click(function() {
        $('textarea.product-options-textarea.product-options-control').val('');
        $('input.product-options-radiobutton.product-options-control').removeAttr('checked');
        $('[name="properties[Escreva o texto]"]').val('');
        $('[name="properties[Frases]"]:checked').removeAttr('checked');
    });
});




var isValid = false;
var mouseX = 0;
var mouseY = 0;
var popupCounter = 0;
var windowW = window.innerWidth;
var windowH = window.innerHeight;
var nextArrowSVG = '<button type="button" class="slick-next"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M24.56,841.89c-4.46,0-8.97-1.21-13.03-3.75c-11.51-7.21-14.99-22.38-7.78-33.89l240.12-383.3L3.75,37.64 c-7.21-11.5-3.72-26.68,7.78-33.89c11.5-7.21,26.68-3.72,33.89,7.78l247.37,394.88c2.45,3.91,3.75,8.43,3.75,13.05v2.96 c0,4.62-1.3,9.14-3.75,13.05L45.42,830.35C40.75,837.8,32.75,841.89,24.56,841.89z"/> </g> </svg></button>';
var prevArrowSVG = '<button type="button" class="slick-prev"><?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 296.54 841.89" style="enable-background:new 0 0 296.54 841.89;" xml:space="preserve"> <g> <path d="M271.98,0c4.46,0,8.97,1.21,13.03,3.75c11.51,7.21,14.99,22.38,7.78,33.89L52.67,420.94l240.12,383.31 c7.21,11.5,3.72,26.68-7.78,33.89c-11.5,7.21-26.68,3.72-33.89-7.78L3.75,435.47C1.3,431.56,0,427.04,0,422.42v-2.96 c0-4.62,1.3-9.14,3.75-13.05L251.12,11.54C255.79,4.09,263.79,0,271.98,0z"/> </g> </svg></button>';


$(document).ready(function() {

    $(document).on('click', '.custom-spam-mobile1', function() {
        $(".custom-spam-mobile1").removeClass('active');
        $(".custom-spam-mobile2").addClass('active');
        $(".custom-div-mapa").fadeOut();
        $(".div-iframe-maps").fadeIn();
    });

    $(document).on('click', '.custom-spam-mobile2', function() {
        $(".custom-spam-mobile2").removeClass('active');
        $(".custom-spam-mobile1").addClass('active');
        $(".custom-div-mapa").fadeIn();
        $(".div-iframe-maps").fadeOut();
    });

    $(".btn-banner-a-casa").click(function() {
        $('html, body').animate({
            scrollTop: $('.section-a-casa-tour-samurai').offset().top - 50
        }, 800);
    });

    $(document).on('click', '[name="exitModal--Options"]', function(e) {
        var exitModalSelected = $('[name="exitModal--Options"]:checked').val();
        _buildExitModal._goToStep(_buildExitModal._nextStep());
        _buildExitModal._buildOptionsDetails(exitModalSelected);
    });
    $(document).on('click', '[prev-step]', function(e) {
        _buildExitModal._goToStep(_buildExitModal._prevStep());
    });
    $(document).on('change', '.exitModal--Form .form-control', function(e) {
        e.preventDefault();
        _buildExitModal._validateIsFilled($(e.currentTarget), $(e.currentTarget).attr('data-error-msg'));
    });
    $(document).on('click', '.exitModal--Form [type="submit"]', function(e) {
        e.preventDefault();
        _buildExitModal._validateIsPhone($("#exitModal--Customer-Phone"), $("#exitModal--Customer-Phone").attr('data-error-msg'));
        _buildExitModal._validateIsFilled($("#exitModal--Customer-Name"), $("#exitModal--Customer-Name").attr('data-error-msg'));
        _buildExitModal._validateIsFilled($("#exitModal--Customer-Phone"), $("#exitModal--Customer-Phone").attr('data-error-msg'));



        if (isValid === true) {
            $('body').addClass('has--loader');
            createSubscriber($('.exitModal--Form'), "https://script.google.com/a/zissou.com.br/macros/s/AKfycbw4VfWcHD3HlKtaiOGUVNfkC3dk6j91a0WBDytn/exec?", _buildExitModal._doThanks);
        }
    });

    document.addEventListener("mousemove", function(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
        windowW = window.innerWidth;
        windowH = window.innerHeight;
    });

    $(document).mouseleave(function() {
        if (mouseY < 10 && windowW > 767) {
            if (popupCounter < 1 && _helpers._getCookie('ExitModalOpenToday').length === 0) {
                //  if (popupCounter < 1) {
                $('.exitModal--Wrapper').show();
                var now = new Date();
                var time = now.getTime();
                time += (3600 * 1000) * 24;
                now.setTime(time);
                _helpers._setCookie('ExitModalOpenToday', true, 1);
            }
            popupCounter++;
        }
    });

    var telBehavior = function(val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        telBehaviorOpt = { onKeyPress: function(val, e, field, options) { field.mask(telBehavior.apply({}, arguments), options); } };

    $('[mask-phone]').mask(telBehavior, telBehaviorOpt);

});

var createSubscriber = function($form, sheetURL, callback) {
    var settings = {
        "async": true,
        "crossDomain": true,
        "url": sheetURL + $form.serialize(),
        "method": "GET"
    }
    $.ajax(settings).done(function(response) {
        console.log(response);

        ga('send', 'event', 'Exit Modal', 'Lead Captado', $('#exitModal--Customer-Name').val(), '1');
        if (callback) {
            callback();
        }
    });
}

var _helpers = {
    _setCookie: function(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    _getCookie: function(c_name) {
        if (document.cookie.length > 0) {
            c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    }
}
var _buildExitModal = {
    _getCurrentStep: function() {
        return parseInt($('.exitModal--Step.active').attr('data-step'));
    },
    _nextStep: function() {
        return _buildExitModal._getCurrentStep() + 1;
    },
    _prevStep: function() {
        return _buildExitModal._getCurrentStep() - 1;
    },
    _goToStep: function(step) {
        step: step;
        var currentStep = '[data-step="' + _buildExitModal._getCurrentStep() + '"]';
        var stepTarget = '[data-step="' + step + '"]';

        gsap.fromTo('.exitModal--Wrapper .e-content-modal', {
            marginTop: 0,
            opacity: 1,
        }, {
            marginTop: -25,
            opacity: 0,
            duration: .35,
            onComplete: function() {
                $(currentStep).removeClass('active');
                gsap.fromTo('.exitModal--Wrapper .e-content-modal', {
                    marginTop: 25,
                    opacity: 0,
                    onComplete: function() {
                        $(stepTarget).addClass('active');
                    }
                }, {
                    marginTop: 0,
                    opacity: 1,
                    duration: .35
                });
            }
        });
    },
    _buildOptionsDetails: function(option) {
        $('[data-step="2"]').find('.value').html(option);
    },
    _validateIsFilled: function(element, errorMSG) {
        if (element.val() != null && element.val().length > 0) {
            $(element).closest('.form-group').addClass('field--success').removeClass('field--error');
            isValid = true;

            return true;
        } else {
            $(element).closest('.form-group').addClass('field--error').removeClass('field--success');
            isValid = false;

            if (errorMSG) {
                alert(errorMSG);
            }
            return false;
        }
    },
    _validateIsPhone: function(element, errorMSG) {
        var phone = element.val().replace(/\D/g, '');
        if (element.val() != null && element.val().length > 0 && phone.length >= 10) {
            $(element).closest('.form-group').addClass('field--success').removeClass('field--error');
            isValid = true;
            return true;
        } else {
            $(element).closest('.form-group').addClass('field--error').removeClass('field--success');
            isValid = false;

            if (errorMSG) {
                alert(errorMSG);
            }
            return false;
        }
    },
    _doThanks: function(element, errorMSG) {
        _buildExitModal._goToStep(3);
        $('body').removeClass('has--loader');
        gsap.fromTo('.thankYouStep img', {
            marginTop: 25,
            opacity: 0,
            'filter': 'grayscale(100%)',
            '-webkit-filter': 'grayscale(100%)',
            'transform': 'scale(.25) rotate(-35deg)',
            '-webkit-transform': 'scale(.25) rotate(-35deg)'
        }, {
            delay: .35,
            ease: Expo.easeOut,
            marginTop: 0,
            opacity: 1,
            duration: .75,
            'filter': 'grayscale(0%)',
            '-webkit-filter': 'grayscale(0%)',
            'transform': 'scale(1) rotate(0deg)',
            '-webkit-transform': 'scale(1) rotate(0deg)'
        });
    }

}
var _globalComponents = {
    config:{
        $addonSelectorWrapper: $('.addonSelector--Wrapper')
    },
    _store:{
        addons: {}
    },
    defaultLoadingModal:{
        open: function(){
            return document.body.classList.add('has--loader');
        },
        close: function(){
            return document.body.classList.remove('has--loader');
        },
        toggle: function(){
            return document.body.classList.toggle('has--loader');
        },
    },
    buildDropdownSkuSelector: function buildDropdownSkuSelector() {
        var _document = $(document);
        var _productSkuDropdownWrapper = $('.productSkuDropdown--Wrapper');
        var _productSkuDropdownCurrent = _productSkuDropdownWrapper.find('.productSkuDropdown--Current');
        var _productSkuDropdownList = _productSkuDropdownWrapper.find('.productSkuDropdown--List');
        var _productSkuDropdownListItem = _productSkuDropdownWrapper.find('.productSkuDropdown--List---Item');

        _document.on('click', _productSkuDropdownCurrent.selector, function(e) {
            var $this = $(this);
            $('.productSkuDropdown--Wrapper').removeClass('active');
            $('.productSkuDropdown--List').removeClass('active');
            $this.siblings(_productSkuDropdownList.selector.split(' ').pop()).parents('.productSkuDropdown--Wrapper').addClass('active');
            $this.siblings(_productSkuDropdownList.selector.split(' ').pop()).addClass('active');
        });
        _document.on('click', _productSkuDropdownListItem.selector, function(e) {
            var $this = $(this);
            var selectMainTitle = $this.attr('data-main-title');
            var selectSubTitle = $this.attr('data-sub-title');

            $this.parents('.productSkuDropdown--Wrapper').find('[data-bind="select-main-title"]').html(selectMainTitle);
            $this.parents('.productSkuDropdown--Wrapper').find('[data-bind="select-sub-title"]').html(selectSubTitle);

            $(document).trigger("ProductInfoChanged", [$this]);
        });
        _document.on("ProductInfoChanged", function(e, target) {
            var _productSkuDropdownWrapper = $(target).closest('.productSkuDropdown--Wrapper');
            var _productSkuDropdownCurrent = _productSkuDropdownWrapper.find('.productSkuDropdown--Current');
            var _productSkuDropdownList = _productSkuDropdownWrapper.find('.productSkuDropdown--List');
            var _productSkuDropdownListItem = _productSkuDropdownWrapper.find('.productSkuDropdown--List---Item');

            _productSkuDropdownWrapper.removeClass('active');
            _productSkuDropdownList.removeClass('active');
            gsap.fromTo(_productSkuDropdownCurrent.children(), {
                y: 25,
                opacity: 0,
            }, {
                y: 0,
                opacity: 1,
                duration: .5
            }, .25);
        });
        _document.on("mouseup", function(e, target) {
            var $this = $('.productSkuDropdown--List');
            // if the target of the click isn't the container nor a descendant of the container
            if (!$this.is(e.target) && $this.has(e.target).length === 0) {
                $('.productSkuDropdown--Wrapper').removeClass('active');
                $('.productSkuDropdown--List').removeClass('active');
            }
        });
    },
    buildQuantitySkuSelector: function buildQuantitySkuSelector() {
        var _document = $(document);
        var _productQuantitySkuSelectorWrapper = $('.productSkuQty--Wrapper');
        var _productQuantitySkuSelectorChanger = $('.productSkuQty--Wrapper .productSkuQty--Change');
        var _productQuantitySkuSelectorCurrent = $('.productSkuQty--Wrapper [name="quantity"]');
        var _productQuantitySkuSelectorInventory = $('.productSkuQty--Wrapper .js--selected-inventory');
        // _productQuantitySkuSelectorInventory.text($($('[data-product-section-inventory]')[0]).attr('data-product-section-inventory'));

        _productQuantitySkuSelectorChanger.on('click', function(e) {
            e.preventDefault();
            var newSkuQty = $(this).attr('data-operator') === 'add' ?
                (
                    parseInt(_productQuantitySkuSelectorCurrent.val()) + 1 <= parseInt(_productQuantitySkuSelectorInventory.text()) ?
                    parseInt(_productQuantitySkuSelectorCurrent.val()) + 1 :
                    parseInt(_productQuantitySkuSelectorCurrent.val())
                ) :
                (
                    parseInt(_productQuantitySkuSelectorCurrent.val()) - 1 > 0 ?
                    parseInt(_productQuantitySkuSelectorCurrent.val()) - 1 :
                    1
                );
            $(document).trigger("ProductQtyChanged");
            _productQuantitySkuSelectorCurrent.val(newSkuQty);
        });
        _document.on("ProductInfoChanged", function() {
            $(document).trigger("ProductQtyChanged");
            _productQuantitySkuSelectorCurrent.val(1);
        });
        _document.on("ProductQtyChanged", function() {
            gsap.fromTo(_productQuantitySkuSelectorCurrent, .5, {
                y: -10,
                opacity: 0,
            }, {
                y: 0,
                opacity: 1,
                stagger: .25
            });
        });
    },
    addTemporaryClass: function(_class, _timeActive, _item) {
        // SplashItem
        var itemToAddClass = _item;
        var tempClass = _class;
        var timeActive = _timeActive;

        if (itemToAddClass && tempClass && timeActive) {
            $(itemToAddClass).addClass(tempClass);
            setTimeout(function() {
                $(itemToAddClass).fadeIn().removeClass(tempClass);
            }, timeActive);
        }
    },
    getImageLightness: function(imageSrc, callback) {
        var img = document.createElement("img");
        img.crossOrigin = "Anonymous";
        img.src = imageSrc;
        img.style.display = "none";
        document.body.appendChild(img);

        var colorSum = 0;

        img.onload = function() {
            // create canvas
            var canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);

            var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var data = imageData.data;
            var r, g, b, avg;

            for (var x = 0, len = data.length; x < len; x += 4) {
                r = data[x];
                g = data[x + 1];
                b = data[x + 2];

                avg = Math.floor((r + g + b) / 3);
                colorSum += avg;
            }

            var brightness = Math.floor(colorSum / (this.width * this.height));
            callback(brightness);
        }
    },
    getInstallmentInfos: function getInstallmentInfos(value, installments, target) {
        var installmentValue = value;
        var installments = installments;
        var tax = 0.005;
        var installmentTax = 0;

        if (installments === 1) {
            installmentTax = 0;
        } else if (installments <= 6) {
            installmentTax = 0;
        } else {
            installmentTax = ((installments - 6) * tax);
        }
        var installmentAmount = (installmentValue + (installmentValue * installmentTax)) / installments
        var installmentTotalAmount = installmentValue + (installmentValue * installmentTax)
        var _installmentOBJ = {
                installmentValue: installmentValue,
                installments: installments,
                tax: tax,
                installmentTax: installmentTax,
                installmentAmount: installmentAmount,
                installmentTotalAmount: installmentTotalAmount
            }
            // debugger;
        if (target) {
            // $(target).find('[installment-qty]').html(installments+'x');
            // $(target).find('[installment-amount]').html(Shopify.formatMoney(installmentAmount*100));
            // $(target).find('[installment-total-amount]').html(Shopify.formatMoney(installmentTotalAmount*100));
            // $(target).find('[installment-total-tax]').html(((installmentTax * 100).toFixed(2))+'%');
        }

        return _installmentOBJ
    },
    calculatePrice: function calculatePrice(){
        // TODO: calculate-price
        // var _price = $
        // var _singlePayment = await EvolveCore.PaymentConditions.calculatePrice(_productTotalPrice);
        // $('.js--selected-single_payment-price').html(Shopify.formatMoney(_singlePayment.calculated_price));
    },
    setVariantInfos: async function setVariantInfos(variant,target){
        var variantTarget = $(`[variant-target="${target}"]`).length ? $(`[variant-target="${target}"]`) : target;
        var _barcode = variant.barcode;
        var _title = variant.title.split(' (')[0]?variant.title.split(' (')[0].replace(')', ''):'';
        var _size = variant.title.split(' (')[1]?variant.title.split(' (')[1].replace(')', ''):'';
        var _variantPrice = variant.title.replace('R$', '').replace('.', '').replace(',', '').replace(' ', '');
        var _productTotalPrice = ProductJS.variantSelected._store.reduce(function(prev, cur){
            return prev + (cur.price || 0)
        },0)
        var _singlePayment = await EvolveCore.PaymentConditions.calculatePrice(_productTotalPrice);
        var _installmentPayment = await EvolveCore.PaymentConditions.calculatePrice(_productTotalPrice, 'without_addition');
        var _comparePrice = await EvolveCore.PaymentConditions.calculatePrice(variant.compare_at_price)

        var _inventory = variant.inventory_quantity;
        var _description = variant.description;
        var _variantID = variant.id;
        
        for (let i = 0; i < variantTarget.length; i++) {
            const target = $(variantTarget)[i];
            $(target).find('[variant-barcode], .js--selected-barcode').html(_barcode);
            $(target).find('[variant-title], .js--selected-title').html(_title);
            $(target).find('[variant-size], .js--selected-size').html(_size);
            $(target).find('[variant-inventory], .js--selected-inventory').html(_inventory);
            $(target).find('[variant-description], .js--selected-description').html(_description);   
        }
        $('[variant-single_payment-price], .js--selected-single_payment-price').html(Shopify.formatMoney(_singlePayment.calculated_price));
        $('[variant-single_payment-price-installment-qty], .js--selected-single_payment-price-installment-qty').html(_singlePayment.installment_number === 1 ? `à vista`: `${_singlePayment.installment_number}x`);
        $('[variant-single_payment-installment-rate], .js--selected-single_payment-installment-rate').html(((_singlePayment.rate * 100)) + '%');
        $('[variant-single_payment-installment-type], .js--selected-single_payment-installment-type').html(_singlePayment.type === 'Discount'? 'desconto': 'juros');
        
        $('[variant-selected-total], .js--selected-total').html(Shopify.formatMoney(_installmentPayment.calculated_price));
        $('[variant-installment-qty], .js--selected-installment-qty').html(_installmentPayment.installment_number === 1 ? `à vista`: `${_installmentPayment.installment_number}x`);
        $('[variant-installment-amount], .js--selected-installment-amount').html(Shopify.formatMoney(_installmentPayment.installment_price));
        $('[variant-installment-total-amount], .js--selected-installment-total-amount').html(Shopify.formatMoney(_installmentPayment.calculated_price));
        $('[variant-installment-type], .js--selected-installment-type').html(_installmentPayment.type === 'Discount'? 'desconto': 'juros');
        $('[variant-installment-total-rate], .js--selected-installment-total-tax').html(((_installmentPayment.rate * 100).toFixed(2)) + '%');

        $('.skus-wrapper-total').addClass('e-active');

        if($('body').hasClass('travesseiro-zissou')) {     
          let _oldPrice = _comparePrice.installment_price
          if($(`.e-product-old-price`).length <= 0) { 
            $(".e-product-price").prepend(`<div class='e-product-old-price'>DE <span class="e-product-old-price--value">${Shopify.formatMoney(_oldPrice)}</span> POR</div>`);
            $(`.e-product-old-price`).css({'min-width': '100%', 'margin-bottom': '10px', 'font-size': '1rem' ,'font-weight': '600'}) 
            $(`.e-product-old-price--value`).css({'font-size': '1.2rem', 'font-weight': '700', 'text-decoration': 'line-through'})                   
          } else { 
            $(`.e-product-old-price--value`).text(`${Shopify.formatMoney(_oldPrice)}`)
            }
        }

        
        $(document).trigger("SetProductRecommendation");
        $(document).trigger("ProductInfoChanged", [$(document)]);
    },
    buildAddonSelector: function buildAddonSelector(target){
        var _document = $(document);
        var _addonSelectorWrapper = $('.addonSelector--Wrapper');

        var buildAddonWidget = function(addonID){
            var addon = _EVClient.ProductAddons._store.filter(function(addon){
                return addon.product_id === addonID
            })[0]
            var addonWidget = $(_globalComponents.config.$addonSelectorWrapper).attr('data-product-id', target)

            // _globalComponents._store.addons = new Vue({
            //     el: `#addonSelector__Wrapper--${target}`,
            //     addonWidgetStore,
            //     delimiters: ['{{', '}}'],
            //     data() {
            //         return {
            //             addon: addon
            //         }
            //     }
            // })

        };
        if(!_EVClient.ProductAddons._store){
            _EVClient.ProductAddons.get()
                .then(function(response) {
                    buildAddonWidget(target)
                })
                .catch(function(error) {
                    new Error(`Unable to create add-on widget to product ID ${target}`)
                });
        } else {
            buildAddonWidget(target)
        }
    },
    buildStoresWidget: function buildStoresWidget() {
        var _document = $(document);
        var _StoresWidget = $('.stores.widget__stores');
        var _StoresSlider = $('.stores__images--list');
        var _StoresCategories = _StoresWidget.find('[to-category]');
        
        _StoresSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            // debugger;
            _StoresCategories.removeClass('is--active')
            _StoresWidget.find(`[to-category=${nextSlide+1}]`).addClass('is--active');
        });
        _document.on('click', _StoresCategories.selector, function(e) {
            var $this = $(this);
            // debugger;
            _StoresSlider.slick('slickGoTo', parseInt($(e.currentTarget).attr('to-category')) - 1)
            
        });
    },
    buildStoreReviewsWidget: async function buildStoreReviewsWidget(selector, source) {
        try {
            var buildReviewRating = function(rating){
                var reviewRatingContent = '';
                for (let i = 0; i < rating; i++) {
                    reviewRatingContent += `<i class="spr-icon spr-icon-star" style=""></i>`
                }
                return reviewRatingContent
            }
            var buildStoreReview = function (name, location, description, rating) {
                return `
                    <li class="store-reviews__item">
                        <div class="store-reviews__item--inner">
                            <div class="store-reviews__item__header">
                                <h3 class="store-reviews__item__title">${name}</h3>
                                <span class="store-reviews__item__location">${location}</span>
                            </div>
                            <div class="store-reviews__item__content">
                                <div class="store-reviews__item__description">${description}</div>
                            </div>
                            <div class="store-reviews__item__footer">
                                ${1+1===3?
                                    `<div class="store-reviews__item__rating">
                                        <div class="store-reviews__item__rating--item">${buildReviewRating(rating)}</div>
                                    </div>` : ``
                                }
                            </div>
                        </div>
                    </li>
                `
            }
            var storeReviews = await axios.get(`${source}`)
            var reviewContent = '';
                storeReviews.data.reviews.map(review => {
                    reviewContent += buildStoreReview(review.customer.name, review.customer.location, review.content.testimonial, review.content.rating)
                    return review
                })
            $(selector).html(reviewContent)
            $(selector).on('afterChange', function(event, slick, currentSlide, nextSlide){
                var allSlides = slick.$slides.length
                var activeSlides = $(slick.$slider).find('.slick-active')
                var firstActiveSlide = +$(activeSlides[0]).attr('data-slick-index') + 1
                var lastActiveSlide = +$(activeSlides[activeSlides.length - 1]).attr('data-slick-index') + 1
                $(slick.$slider).siblings('[store-reviews-pagination]').html(`Mostrando de ${firstActiveSlide} - ${lastActiveSlide} de <b>${allSlides} reviews</b>`)
            });
            $(selector).on('init', function(event, slick){  
                var allSlides = slick.$slides.length
                var activeSlides = $(slick.$slider).find('.slick-active')
                var firstActiveSlide = +$(activeSlides[0]).attr('data-slick-index') + 1
                var lastActiveSlide = +$(activeSlides[activeSlides.length - 1]).attr('data-slick-index') + 1 
                
                $(slick.$slider).siblings('[store-reviews-pagination]').html(`Mostrando de ${firstActiveSlide} - ${lastActiveSlide} de <b>${allSlides} reviews</b>`)
            });
            $(selector).slick({
                infinite: true,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true
                    }
                }]
            });   
            
        } catch (e) {
            // debugger;
            new Error('Erro ao recuperar store reviews', e.message)
        }
    },
    buildStorePressWidget: async function buildStorePressWidget(selector, source) {
        try {
            var buildStorePress = function (press) {
                return `
                    <li class="store-press__item">
                        <div class="store-press__item--inner">
                            <div class="store-press__item__content">
                                <div class="store-press__item__logo">
                                    <img src="${press.source.logo}"/>
                                </div>
                            </div>
                            <div class="store-press__item__footer">
                                <div class="store-press__item__cta">
                                    <a href="${press.content.url}">+ Veja Mais</a>
                                </div>
                            </div>
                        </div>
                    </li>
                `
            }
            var storePress = await axios.get(`${source}`)
            var pressContent = '';
            storePress.data.news.map(press => {
                pressContent += buildStorePress(press)
                return press
            })
            $(selector).html(pressContent)
            $(selector).on('afterChange', function(event, slick, currentSlide, nextSlide){
                var allSlides = slick.$slides.length
                var activeSlides = $(slick.$slider).find('.slick-active')
                var firstActiveSlide = +$(activeSlides[0]).attr('data-slick-index') + 1
                var lastActiveSlide = +$(activeSlides[activeSlides.length - 1]).attr('data-slick-index') + 1
                $(slick.$slider).siblings('[store-press-pagination]').html(`Mostrando de ${firstActiveSlide} - ${lastActiveSlide} de <b>${allSlides} notícias</b>`)
            });
            $(selector).on('init', function(event, slick){  
                var allSlides = slick.$slides.length
                var activeSlides = $(slick.$slider).find('.slick-active')
                var firstActiveSlide = +$(activeSlides[0]).attr('data-slick-index') + 1
                var lastActiveSlide = +$(activeSlides[activeSlides.length - 1]).attr('data-slick-index') + 1 
                
                $(slick.$slider).siblings('[store-press-pagination]').html(`Mostrando de ${firstActiveSlide} - ${lastActiveSlide} de <b>${allSlides} notícias</b>`)
            });
            $(selector).slick({
                infinite: true,
                autoplay: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        centerMode: true,
                        arrows: false
                    }
                }]
            });   
            
        } catch (e) {
            // debugger;
            new Error('Erro ao recuperar store press', e.message)
        }
    },
    buildTabs: function buildTabs(selector, options={}) {
        var _document = $(document);
        if(!$(selector).length){
            return
        }
        options.default = '[data-tab-default]';
        window.tabs = new Tabby(selector, options);
        tabs.toggle(document.querySelector('[data-tab-default]'))
        var setTab = function (tab, content, animate=true) {
            
            var tabBgUrl = null;
            if(window.outerWidth >= 1280){
                var tabBgUrl = $(content).find('[tab-bg] img').attr('src') || $(content).find('[tab-bg] img').attr('data-src');;
            } else{
                var tabBgUrl = $(content).find('[tab-bg] img').attr('src') || $(content).find('[tab-bg] img').attr('data-src');;
            }
            if(tabBgUrl){
                $(tab).closest('[tab-bg-target]').addClass('has--background')
            } else {
                $(tab).closest('[tab-bg-target]').removeClass('has--background')
            }
            if(animate){
                $('html, body').animate({
                    scrollTop: $(tab).closest('[tab-bg-target]').offset().top - 50
                    // scrollTop: 443
                }, 900);
            }
        }
        document.addEventListener('tabby', function (event) {
            var tab = event.target;
            var content = event.detail.content;
            setTab(tab, content)
        }, false);
        
        setTab(document.querySelector('[data-tab-default]'),document.querySelector(document.querySelector('[data-tab-default]').getAttribute('href')), false)
    },
}
function checkSPOExists() {
    if (typeof app !== 'undefined') {
        console.log('app existe');

        app.goToCart = function() { alert('edit gotocart'); }
    } else {
        console.log('app nao existe');
    }
};

var checkifCartIsOpen = function() {
    if ($('.x-minicart').hasClass('is--active')) {
        CartJS.addSuccess();
    } else {
        $('.x-minicart__item').removeClass('active');
    }
};
setInterval(function() {
    checkifCartIsOpen();
}, 1000);


document.addEventListener("_EV.cart:preload", function(e) {
    _globalComponents.defaultLoadingModal.open();
});
document.addEventListener("_EV.cart:prefill", function(e) {
    _globalComponents.defaultLoadingModal.open();
});
document.addEventListener("_EV.cart:prefill:success", function(e) {
    _globalComponents.defaultLoadingModal.close();
});
document.addEventListener("_EV.cart:prefill:error", function(e) {
    _globalComponents.defaultLoadingModal.close();
});
document.addEventListener("_EV.cart:preload:error", function(e) {
    _globalComponents.defaultLoadingModal.close();
});
$(document).ready(function() {
    _globalComponents.buildDropdownSkuSelector();
    _globalComponents.buildQuantitySkuSelector();
    _globalComponents.buildStoresWidget();
    document.addEventListener("_EV.core:initialized", function(e) {
        for (var i = 0; i < _globalComponents.config.$addonSelectorWrapper.length; i++) {
            var addonSelector = _globalComponents.config.$addonSelectorWrapper[i];
            var _addonSelectorTarget = $(addonSelector).attr('data-product-id');
            _globalComponents.buildAddonSelector(parseInt(_addonSelectorTarget));
        }
    });

    
    _EVClient.Init().then(() => {
        _EVClient.Auth().then(function(token){
            _EVClient.GetCheckoutStatus()
        })
    })
    var flag = localStorage.getItem('btncomprar');

    //if(flag=="true"){$('.x-minicart').addClass('is--active');}
    localStorage.setItem('btncomprar', false);
    var _tabs = [
        {
            selector: '[data-tabs]',
            options: {
            }
        }
    ];
    var _storeReviews = [
        {
            selector: '[store-reviews]',
            source: 'https://endx74tox2eq33v.m.pipedream.net',
            options: {
            }
        }
    ];
    var _storePress = [
        {
            selector: '[store-press]',
            source: 'https://encaojf2lmnebmf.m.pipedream.net',
            options: {
            }
        }
    ];
    var _sliders = [
        {
            selector: $('.lencol-duvet-landing-page .e-product-works__preferences___slider'),
            options: {
                infinite: true,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 5000,

                speed: 50,

                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,
                arrows: false,
                asNavFor: '.lencol-duvet-landing-page .e-product-works__preferences___slider'
            }
        },
        {
            selector: $('.jogo-de-lencol-zissou .e-product-works__preferences___slider'),
            options: {
                infinite: true,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 2500,

                speed: 50,

                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,
                arrows: false,
                asNavFor: '.jogo-de-lencol-zissou .e-product-works__preferences___slider'
            }
        },
        {
            selector: $('.e-product-human-friendly__Images .e-product-human-friendly__Images-List'),
            options: {
                infinite: true,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 200000,

                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: true
                    }
                }]
            }
        },
        {
            selector: $('.e-product-leva__Images .e-product-leva__Images-List'),
            options: {
                infinite: true,
                // fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 4000,

                slidesToShow: 1,
                slidesToScroll: 1,

                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,

                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: true
                    }
                }]
            }
        },
        {
            selector: $('.stores__images--list'),
            options: {
                infinite: true,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 4000,

                slidesToShow: 1,
                slidesToScroll: 1,

                // prevArrow: prevArrowSVG,
                // nextArrow: nextArrowSVG,
                arrows: false,

                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }]
            }
        },
        {
            selector: $('.fullpage-slider__images--slider'),
            options: {
                infinite: true,
                fade: true,
                
                dots: true,
                
                cssEase: 'linear',
                lazyLoad: 'ondemand',

                autoplay: true,
                autoplaySpeed: 4000,

                slidesToShow: 1,
                slidesToScroll: 1,

                prevArrow: prevArrowSVG,
                nextArrow: nextArrowSVG,

                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: true
                    }
                }]
            }
        },
    ];

    for (let i = 0; i < _storeReviews.length; i++) {
        const _storeReviewWidget = _storeReviews[i];
        if(!!$(_storeReviewWidget.selector).length){
            _globalComponents.buildStoreReviewsWidget(_storeReviewWidget.selector, $(_storeReviewWidget.selector).attr('data-source'));
        }
    };
    for (let i = 0; i < _storePress.length; i++) {
        const _storePressWidget = _storePress[i];
        if(!!$(_storePressWidget.selector).length){
            _globalComponents.buildStorePressWidget(_storePressWidget.selector, $(_storePressWidget.selector).attr('data-source'));
        }
    };
    for (let i = 0; i < _tabs.length; i++) {
        const _tab = _tabs[i];
        _globalComponents.buildTabs(_tab.selector, _tab.options);
    };
    for (let i = 0; i < _sliders.length; i++) {
        const _slider = _sliders[i];
        _slider.selector.slick(_slider.options);
        _slider.selector
            .on('swipe afterChange', function(event, slick, direction) {
                setTimeout(function() {
                    $('.js--lazy').lazy({ enableThrottle: true, effect: 'fadeIn', effectTime: 500, visibleOnly: true, throttle: 100 });
                }, 150);
            });
    };
    if($('.klabin--interactive--toggle-views [data-toggle]').length) {
        $(document).on('click touchend', '[data-toggle]', function(e){
            e.preventDefault();
            $('.klabin--interactive--toggle-views [data-toggle]').removeClass('is--active');
            $('.klabin--interactive[data-target]').removeClass('is--active');
            $(e.currentTarget).addClass('is--active');
            $(`.klabin--interactive[data-target="${$(e.currentTarget).attr('data-toggle')}"]`).addClass('is--active');
            $('.js--lazy').lazy({
                enableThrottle: true,
                effect: 'fadeIn', effectTime: 500,
                visibleOnly: true,
                throttle: 100
            });
        })
        $($('.klabin--interactive--toggle-views [data-toggle]')[0]).trigger('click')
    };
    if($('.product__qa').length) {
        // $('.product__qa').stickem();
        // When the user scrolls the page, execute myFunction
        //
        if($(window).outerWidth() < 768 && !window.location.href.includes("base-zissou")){
            window.onscroll = function() {StickScroll()};
            var StickScroll = function(){
                // Get the header
                var container = $(".product__qa__tabs")
                var header = $(".product__qa__tabs--nav")
                var scrollTop     = $(window).scrollTop(),
                        elementOffset = $(container).offset().top,
                        distance      = (elementOffset - scrollTop);
    
                var distanceToBottom
                if(distance < 51 && distance > ((container.outerHeight() - 100)  * -1)){
                    // debugger;
                    $(header).addClass('is--fixed')
                } else{
                    $(header).removeClass('is--fixed')
                }
            }
        }

    };
    if($('.comfort-system__tour').length) {
        // $('.product__qa').stickem();
        // When the user scrolls the page, execute myFunction
        var comfortSystemTourPlaying = false
        window.onscroll = function() {StickScroll()};
        var StickScroll = function(){
            // Get the header
            var elem = $(".comfort-system__tour .product-section__header--subtitle")[0]
            var container = $(".comfort-system__tour")
            var header = $(".product__tour__canvas")
                            
                var distanceTop = elem.getBoundingClientRect().top
                var distanceBottom = elem.getBoundingClientRect().bottom


            var distanceToBottom
            if(!comfortSystemTourPlaying && distanceTop < 50 && distanceBottom < 50){
                // debugger;
                // comfortSystemTourPlaying = true
                // alert('play comfortSystem')
                // $(header).addClass('is--fixed')
                // $('.comfort-system__tour [data-change-chapter="1"]').trigger('click')
            } else{
                $(header).removeClass('is--fixed')
                $('.comfort-system__tour [data-change-chapter="0"]').trigger('click')
                $('.comfort-system__tour [data-change-chapter="0"]').trigger('touchend')
                // comfortSystemTourPlaying = false
            }
        }

        document.addEventListener("_EV.ProductTour:ended:chapter", function(e) {
            var content = e.detail;
            if(content.handle === "ch_1" && $(".product__qa").length){
                // $(".product__tour__canvas").removeClass('is--fixed')
                // return $('html, body').animate({
                //     scrollTop: $(".product__qa").offset().top - 50
                //     // scrollTop: 443
                // }, 900);
            }
        });
        

    };
    if($('.product__tour').length) {
        var comfortSystemTourPlaying = false
        window.onscroll = function() {StickScroll()};
        document.addEventListener("_EV.ProductTour:ended:chapter", function(e) {
            StickScroll();
        });
        var StickScroll = function(){
            var elem = $(".product__tour")[0]
            var distanceTop = elem.getBoundingClientRect().top
            var distanceBottom = elem.getBoundingClientRect().bottom
            if(distanceTop < $(window).outerHeight()){
                if(distanceBottom >  $(window).outerHeight()){
                    $('.widget__floating-bar').removeClass('is--active')
                } else{
                    $('.widget__floating-bar').addClass('is--active')
                }
            } 
        }

    };
    
    if($('.lp-comparativo .page__teaser.comparison').length) {
        var StickScroll = function(elem){
            $(window).on('scroll', function(){
                var container = $(elem)
                var header = $(elem)
                
                var distanceTop = elem.getBoundingClientRect().top
                var distanceBottom = elem.getBoundingClientRect().bottom

                // console.log(`distanceTop: ${distanceTop}`)
                // console.log(`distanceBottom: ${distanceBottom}`)
                if(distanceBottom < 50){
                    $(header).addClass('is--affix--bottom')
                    
                } else {
                    $(header).removeClass('is--affix--bottom')
                }
                if(distanceTop < 51){
                    // console.log(top, bottom)
                    $(header).addClass('is--affix')
                    
                    
                } else{
                    $(header).removeClass('is--affix')
                    $(header).removeClass('is--affix--bottom')
                }
            })
        }
        for (let i = 0; i < $('.lp-comparativo .page__teaser.comparison').length; i++) {
            var element = $('.lp-comparativo .page__teaser.comparison')[i];
            // debugger;
            console.log(element);
            if($(window).outerWidth() < 768){
                StickScroll(element)
            }
            // $(window).on('scroll', function(){
            // })
            // window.onscroll = function() {};
        }

    };
    for (let i = 0; i < $('[installment-calculator]').length; i++) {
        let installmentValue = parseInt($($('[installment-calculator]')[i]).attr('installment-value'));
        let installments = parseInt($($('[installment-calculator]')[i]).attr('installments'));
        let _installmentOBJ = _globalComponents.getInstallmentInfos(installmentValue, installments, $('[installment-calculator]')[i]);
        debugger;

        $('.js--selected-installment-qty').html(_installmentOBJ.installments + 'x');
        $('.js--selected-installment-amount').html(Shopify.formatMoney(_installmentOBJ.installmentAmount));
        $('.js--selected-installment-total-amount').html(Shopify.formatMoney(_installmentOBJ.installmentTotalAmount));
        $('.js--selected-installment-total-tax').html(((_installmentOBJ.installmentTax * 100).toFixed(2)) + '%');
    };

    $(document).on('click touchend', '.e-product-perfect__title____label', function(e) {
        e.preventDefault();
        var currentText = $(e.currentTarget).parents('.e-product-perfect__item').find('.e-product-perfect__text');

        $(e.currentTarget).parents('.e-product-perfect__item').find('.e-product-perfect__title____label').toggleClass('e-product-perfect__item--text--active')
        $(currentText).toggleClass('text--active');
        $("html, body").animate({
            scrollTop: $(e.currentTarget).offset().top - (window.innerWidth >= 1280 ? 125 : 45)
        }, 350);


    });
    $(document).on('click touchend', '.notice-me', function(e) {
        if(!$(this).hasClass('buyFromPartner')){
            e.preventDefault();
            window.open('https://api.whatsapp.com/send?phone=5511932858213');
        }
    });
    $(document).on('click touchend', '.e-header__navigation__dropdown-toggle', function(e) {
        e.preventDefault();
        $(e.currentTarget).closest('.e-header__navigation-item').toggleClass('is--active')
        // $(e.currentTarget).closest('.e-header__navigation-item').find('.e-header__navigation-sub').slideToggle()
    });

    if($('.widget__store-locator').length){
        document.addEventListener(`_EV.Dropdown:Item:set`, function(e) {
            // debugger;
            $(`.Dropdown__Wrapper[target="${e.detail.category}"]`)
                .closest('.store-locator__selector')
                .find(`.store-locator__address`)
                .html(`${e.detail.address_1} <br> ${e.detail.address_2} <br> ${e.detail.city} - ${e.detail.state} <br> ${e.detail.zipcode}`)
        })
    }
});




$(document).on("ready", function(){

let src = $(".allTheWay.product__features--media-inner img").attr("data-src", )
$(".allTheWay.product__features--media-inner img").attr("src", src)

 $('.x-product__img-items').on("DOMSubtreeModified",function(){
   if($("#slick-slide10").hasClass("slick-current")){
    $(".e-center  .e-main-banner__title").removeClass("e-active")
  }
  else{
    $(".e-center  .e-main-banner__title").addClass("e-active")
  
  }

})



})

$(document).on("ready", function(){ 
    if($('[data-product-section-title="Casal"]').length > 0 && $( 'body').hasClass("base-zissou")){ 
        $('[data-product-section-title="Casal"]').trigger('click')
    }

})